const messages = {
  'en-US': {
    app: {
      name: 'EHD Builders CRM',
      tagline: 'Sales, contracts, projects and finance in one workspace.'
    },
    common: {
      dashboard: 'Dashboard',
      workbench: 'Workbench',
      back: 'Back',
      save: 'Save',
      cancel: 'Cancel',
      search: 'Search',
      reset: 'Reset',
      refresh: 'Refresh',
      create: 'Create',
      edit: 'Edit',
      delete: 'Delete',
      download: 'Download',
      upload: 'Upload',
      export: 'Export',
      overview: 'Overview',
      details: 'Details',
      empty: 'No data yet',
      loading: 'Loading...',
      language: 'Language',
      appearance: 'Appearance',
      lightMode: 'Light',
      darkMode: 'Dark',
      logout: 'Log out',
      role: 'Role',
      account: 'Account',
      today: 'Today',
      thisWeek: 'This week',
      thisMonth: 'This month',
      thisYear: 'This year',
      all: 'All',
      status: 'Status',
      actions: 'Actions',
      amount: 'Amount',
      date: 'Date',
      notes: 'Notes',
      confirm: 'Confirm',
      tip: 'Notice',
      pleaseSelect: 'Please select',
      selectDate: 'Select date',
      dateRangeStart: 'Start',
      dateRangeEnd: 'End',
      loadFailed: 'Load failed',
      self: 'Me',
      active: 'Active',
      inactive: 'Inactive',
      failed: 'Something went wrong',
      saved: 'Saved',
      created: 'Created',
      deleted: 'Deleted',
      uploaded: 'Uploaded',
      approved: 'Approved',
      rejected: 'Rejected',
      submitted: 'Submitted',
      username: 'Username',
      password: 'Password',
      keyword: 'Keyword',
      required: 'Required',
      requiredSelect: 'Please select',
      loadingShort: 'Loading…',
      yes: 'Yes',
      no: 'No',
      selectAll: 'Select all',
      clearAll: 'Clear',
      nextAppt: 'Next appointment',
      optional: 'Optional',
      firstName: 'First name',
      lastName: 'Last name',
      company: 'Company',
      source: 'Source',
      contactSection: 'Contact',
      sourceSection: 'Source & follow-up',
      assignSales: 'Assign sales',
      content: 'Content',
      time: 'Time',
      creator: 'Created by',
      logoutConfirm: 'Log out from the current workspace?',
      logoutAction: 'Log out',
      backToList: 'Back to list',
      downloadFailed: 'Download failed',
      uploadFailed: 'Upload failed',
      linkCopied: 'Link copied',
      linkGenFailed: 'Failed to generate link',
      recordNotFound: 'Record not found',
      unnamedTemplate: 'Unnamed template',
      monthsHint: 'months (default 12; end = start + term)',
      unnamed: 'Unnamed',
      preview: 'View'
    },
    navGroups: {
      workspace: 'Workspace',
      pipeline: 'Pipeline',
      finance: 'Finance',
      insights: 'Insights',
      admin: 'Administration'
    },
    nav: {
      dashboard: 'Dashboard',
      leads: 'Leads',
      customers: 'Customers',
      opportunities: 'Opportunities',
      quotes: 'Quotes',
      contracts: 'Contracts',
      projects: 'Projects',
      products: 'Products',
      subcontractors: 'Partners',
      finance: 'Finance',
      reports: 'Reports',
      schedule: 'Schedule',
      templates: 'Templates',
      settings: 'Settings',
      emailConfig: 'Email configuration',
      users: 'Users',
      roles: 'Roles',
      menus: 'Menus',
      systemOverview: 'System overview',
      changeOrders: 'Change orders',
      salesAmount: 'Sales entry',
      home: 'Home'
    },
    pipelineList: {
      leads: 'Track ownership, appointments and conversion readiness in one list.',
      customers: 'Companies, contacts, addresses and lifecycle — aligned with Salesforce Accounts.',
      opportunities: 'Stages drive win probability; from lead conversion or created standalone.',
      quotes: 'Internal approval, email quote to customer, and handoff to contracts.',
      contracts: 'Track signature and project link after approved quotes.',
      projects: 'Delivery codes, status and PM financial fields.',
      subcontractors: 'Suppliers and subcontractors: one directory for procurement payees and field partners.',
      changeOrders: 'Scope or amount adjustments pending office approval.',
      fromQuote: 'Create from quote',
      newChangeOrder: 'New change order',
      contractTemplates: 'Manage .docx templates and uploads used when creating contracts from quotes.'
    },
    leadListPage: {
      create: 'New lead',
      salesOwner: 'Sales owner',
      leadStatusFilter: 'Lead status',
      appointmentFrom: 'Appointment from',
      appointmentTo: 'Appointment to',
      leadNo: 'Lead #',
      contactName: 'Contact',
      appointmentDate: 'Appointment date',
      createdAt: 'Created at',
      viewDetails: 'View details',
      assignSales: 'Assign sales',
      assignDialogTitle: 'Assign sales',
      loadSalesFailed: 'Failed to load sales list',
      unnamed: 'Unnamed',
      selectSalesOwnerWarn: 'Please select a sales owner',
      assignSuccess: 'Assigned successfully',
      assignFailed: 'Assignment failed',
      markLost: 'Lost',
      confirmMarkLost: 'Mark this lead as lost?',
      confirmDelete: 'Delete this lead? (Soft delete)',
      deleteSuccess: 'Deleted',
      latestNote: 'Latest internal note',
      latestFollowup: 'Latest follow-up'
    },
    routeTitles: {
      home: 'Home',
      leadNew: 'New lead',
      leadEdit: 'Edit lead',
      leadDetail: 'Lead detail',
      customerNew: 'New customer',
      customerEdit: 'Edit customer',
      opportunityNew: 'New opportunity',
      opportunityDetail: 'Opportunity detail',
      quoteNew: 'New quote',
      quoteEdit: 'Edit quote',
      contractFromQuote: 'Create contract from quote',
      contractDetail: 'Contract detail',
      projectDetail: 'Project detail',
      subcontractorNew: 'New partner',
      subcontractorEdit: 'Edit partner',
      contractTemplateNew: 'New contract template',
      contractTemplateEdit: 'Edit contract template'
    },
    grid: {
      number: 'No.',
      title: 'Title',
      code: 'Code',
      name: 'Name',
      createdAt: 'Created at',
      company: 'Company',
      contact: 'Contact',
      phone: 'Phone',
      email: 'Email',
      customerNo: 'Customer #',
      leadNo: 'Lead #',
      customer: 'Customer',
      leadDisplayName: 'Lead name',
      stage: 'Stage',
      totalUsd: 'Total (USD)',
      winPct: 'Win %',
      closeDate: 'Close date',
      owner: 'Owner',
      quote: 'Quote',
      template: 'Template',
      project: 'Project',
      contractId: 'Contract ID',
      amountDelta: 'Amount Δ',
      approval: 'Approval',
      description: 'Description',
      profit: 'Profit',
      pmCommission: 'PM commission',
      licenseNo: 'License #',
      dba: 'Trade name',
      personName: 'Name',
      version: 'Version',
      username: 'Username',
      realName: 'Name',
      roles: 'Roles',
      roleCode: 'Role code',
      roleName: 'Role name',
      userCount: 'Users',
      menuCount: 'Items',
      route: 'Route',
      permissionCode: 'Permission',
      menuGroup: 'Group',
      icon: 'Icon',
      visibility: 'Display',
      sortOrder: 'Sort',
      content: 'Content',
      time: 'Time',
      createdBy: 'Created by',
      contract: 'Contract',
      type: 'Type',
      menuTypeMenu: 'Menu',
      menuTypeButton: 'Button',
      visibleShow: 'Shown',
      visibleHide: 'Hidden',
      revenue: 'Revenue',
      expenseOut: 'Expense',
      changeOrderNoShort: 'Change no',
      fileName: 'File',
      fileSource: 'Source',
      lineItem: 'Item',
      qtyShort: 'Qty',
      unitPrice: 'Unit price',
      lineSubtotal: 'Amount',
      viewProject: 'View'
    },
    loginPage: {
      subtitle: 'Sign in to your workspace',
      account: 'Account',
      password: 'Password',
      accountPh: 'Enter username',
      passwordPh: 'Enter password',
      submit: 'Sign in',
      accountRequired: 'Please enter username',
      passwordRequired: 'Please enter password',
      failed: 'Sign-in failed'
    },
    customerListPage: {
      create: 'New customer',
      keywordLabel: 'Keyword',
      keywordPh: 'Name / phone / email',
      salesOwner: 'Sales owner'
    },
    opportunityListPage: {
      create: 'New opportunity',
      ownerFilter: 'Owner',
      open: 'Open'
    },
    quoteListPage: {
      create: 'New quote',
      customerSnapshot: 'Customer (snapshot)',
      quoteNoLabel: 'Quote no.',
      quoteNoPh: 'Fuzzy match on number',
      statusFilter: 'Quote status',
      submitInternal: 'Submit for approval',
      approve: 'Approve',
      reject: 'Reject',
      sendLink: 'Send quote',
      view: 'View',
      submitted: 'Submitted for internal approval',
      approved: 'Approved',
      rejected: 'Rejected',
      rejectReason: 'Rejected',
      linkTitle: 'Link ready',
      linkIntro: 'Customer link (copy):',
      linkEmailed: 'Quote emailed to lead email: {email}.',
      sendModeTitle: 'Send quote',
      sendModeMessage: 'Choose what the customer can see after opening the quote link.',
      sendModeSummary: 'Total only',
      sendModeDetails: 'View details',
      sendQuoteFailTitle: 'Send quote failed',
      sendQuoteFailed: 'Could not email the quote. Check your email (SMTP) settings or try again.',
      failed: 'Action failed',
      createContract: 'Create contract',
      viewContractDetail: 'View contract'
    },
    contractListPage: {
      keywordLabel: 'Keyword',
      statusLabel: 'Status',
      searchPh: 'Search number or title',
      linked: 'Linked',
      notCreated: 'None',
      emptyLoading: 'Loading…',
      emptyHint: 'No contracts yet.',
      gotoQuote: 'Quote'
    },
    changeOrderPage: {
      filterHint: 'Filtered by contract ID {id} (opened from contract).',
      contractFilter: 'Contract',
      changeNoLabel: 'Change no.',
      changeNoPh: 'Fuzzy match',
      approvalFilter: 'Approval',
      newDialog: 'New change order',
      linkContract: 'Contract',
      contractPh: 'Search ID or pick a contract',
      amountPh: 'Positive adds revenue, negative reduces',
      descLabel: 'Description',
      descPh: 'Scope and reason for the change',
      selectContract: 'Please select a contract',
      created: 'Change order created',
      confirmApprove: 'Approve this change order?',
      confirmReject: 'Reject this change order?'
    },
    subcontractorListPage: {
      partyTypeFilter: 'Partner type',
      partyTypeAll: 'All',
      partyTypeCol: 'Type',
      confirmDelete: 'Delete this partner record?',
      keywordLabel: 'Keyword',
      keywordPh: 'Company / DBA / contact / license'
    },
    productListPage: {
      keywordLabel: 'Keyword',
      keywordPh: 'Product name / code / description',
      statusAll: 'All',
      confirmDelete: 'Delete this product? Existing quotes keep their saved snapshot.'
    },
    projectListPage: {
      keywordLabel: 'Keyword',
      keywordPh: 'Project code or name',
      customerCol: 'Customer',
      customerPhoneCol: 'Customer phone'
    },
    templateListPage: {
      keywordLabel: 'Keyword',
      keywordPh: 'Template name or version',
      placeholderHelp: 'Merge fields',
      preview: 'Preview',
      uploadFile: 'Upload file',
      previewFailed: 'Preview failed',
      confirmDelete: 'Delete template "{name}"?'
    },
    settingsPageExtra: {
      usersSubtitle: 'Manage accounts, role membership and sign-in state.',
      rolesSubtitle: 'Role codes, status and menu/button permissions.',
      menusSubtitle: 'Menus, buttons and navigation metadata.'
    },
    workspaceHints: {
      leadNew: 'Capture contact, company and appointment for follow-up.',
      leadEdit: 'Update contact details, assignment and visit plan.',
      leadDetail: 'Full profile, notes, follow-ups and conversion actions.',
      customerNew: 'Create a customer with contacts, channels and address.',
      customerEdit: 'Adjust company, contacts and lifecycle fields.',
      opportunityNew: 'Define owner, amount, stage and close timeline.',
      opportunityDetail: 'Stage progression, linked quotes and activity.',
      quoteNew: 'Build line items, terms and internal approval flow.',
      quoteEdit: 'Refine scope and pricing before customer approval or signing.',
      contractFromQuote: 'Choose an approved quote, template and generate documents.',
      contractDetail: 'Status, linked project, signature and files.',
      projectDetail: 'Financials, payment plan, documents and delivery status.',
      subcontractorNew: 'Register license, contacts, trade name and partner type.',
      subcontractorEdit: 'Update partner profile and contacts.',
      contractTemplateForm: 'Upload .docx and manage merge placeholders.',
      financeOverview: 'Receivables, payment records and profit view across projects.',
      leadCostMonth:
        'Lead cost (monthly): tiered by each owner’s monthly sales (sum of their projects’ contract totals in that month); batch or per-lead recalc.',
      salesAmount: 'Record monthly sales by salesperson for reporting.'
    },
    systemUsersPage: {
      create: 'New user',
      keywordPh: 'Username / name / email / phone',
      assignRoles: 'Assign roles',
      resetPassword: 'Reset password',
      editUser: 'Edit user',
      newUser: 'New user',
      passwordPh: 'Leave blank for default 123456',
      currentUser: 'User',
      resetPwdTitle: 'Reset password',
      resetPwdHint: 'Set a new password for {username}.',
      newPwdPh: 'New password (min 6 characters)',
      confirmReset: 'Confirm reset',
      rulesUsername: 'Please enter username',
      rulesPwdLen: 'Password cannot exceed 64 characters',
      rulesRealName: 'Please enter name',
      updated: 'User updated',
      created: 'User created',
      saveFailed: 'Save failed',
      statusUpdated: 'Status updated',
      statusFailed: 'Status update failed',
      rolesSaved: 'Roles saved',
      pwdTooShort: 'Enter at least 6 characters',
      pwdReset: 'Password reset',
      pwdFailed: 'Reset failed',
      confirmDelete: 'Delete user {name}?',
      deleted: 'User deleted',
      deleteFailed: 'Delete failed'
    },
    systemRolesPage: {
      create: 'New role',
      keywordPh: 'Code / name / description',
      assignPerm: 'Assign permissions',
      editRole: 'Edit role',
      newRole: 'New role',
      permDialogTitle: 'Menu permissions',
      filterMenuPh: 'Filter menus or permission codes',
      rulesCode: 'Please enter role code',
      rulesName: 'Please enter role name',
      treePrefixBtn: '[Button]',
      updated: 'Role updated',
      created: 'Role created',
      menuLoadFailed: 'Failed to load permission tree',
      permSaved: 'Permissions saved',
      permSaveFailed: 'Failed to save permissions',
      confirmDelete: 'Delete role {name}?',
      deleted: 'Role deleted'
    },
    systemMenusPage: {
      createRoot: 'New top-level menu',
      keywordPh: 'Name / permission / route',
      addChildMenu: 'Add submenu',
      addChildBtn: 'Add button',
      editMenu: 'Edit menu',
      newMenu: 'New menu',
      parentMenu: 'Parent',
      topLevel: 'Top level',
      permPh: 'e.g. SYSTEM_USER_CREATE',
      routePath: 'Route path',
      componentName: 'Component name',
      purpose: 'Purpose',
      defaultChild: 'Default child route',
      badgeType: 'Badge type',
      badgeSource: 'Badge data source',
      externalLink: 'External link',
      hiddenLabel: 'Hidden',
      displayStatus: 'Visibility',
      enableStatus: 'Status',
      showRadio: 'Show',
      hideRadio: 'Hide',
      rulesName: 'Please enter name',
      rulesType: 'Please select type',
      btnNeedPerm: 'Buttons must have a permission code',
      updated: 'Menu updated',
      created: 'Menu created',
      confirmDelete: 'Delete menu {name}?',
      deleted: 'Menu deleted',
      i18nKeyLabel: 'i18n key',
      saveFailed: 'Save failed'
    },
    leadFormPage: {
      editTitle: 'Edit lead',
      newTitle: 'New lead',
      newSubtitle: 'First name required; last name and email optional.',
      leadNo: 'Lead #',
      firstNamePh: 'First name',
      lastNamePh: 'Last name',
      emailPh: 'Email',
      emailInvalid: 'Please enter a valid email address',
      phonePh: 'Phone',
      sourcePh: 'e.g. website, referral…',
      sourcePresetPh: 'Select source',
      sourceYelp: 'Yelp',
      sourceOfficialSite: 'Official website',
      sourceGoogle: 'Google',
      sourceMeta: 'Meta',
      sourceMagazine: 'Magazine',
      sourceOther: 'Other',
      sourceOtherDetail: 'Specify source',
      descriptionLabel: 'Description',
      descriptionPh: 'Brief description to help sales follow up.',
      addressLabel: 'Address',
      addressPh: 'Street, city, state (optional).',
      salesOwnerPh: 'Select sales owner',
      officeOnly: 'Only office or admin can create leads.',
      apptPast: 'Appointment must be today or later',
      saved: 'Saved',
      created: 'Created',
      visitDivider: 'Site visit (Google Calendar)',
      visitAlert:
        'Optional visit window on the appointment date above (business timezone, default America/New_York). Google invites go to the assigned rep and lead email when valid.',
      visitOptional: 'Site visit (optional)',
      start: 'Start',
      end: 'End',
      visitStart: 'Visit start',
      visitEnd: 'Visit end',
      visitStartPh: 'Optional — timed calendar invite',
      visitEndPh: 'Must be after start',
      visitPeriodMorning: 'Morning',
      visitPeriodAfternoon: 'Afternoon',
      visitPeriodPlaceholder: 'AM / PM',
      visitTimePlaceholder: 'Time',
      visitNeedAppointmentDate: 'Pick an appointment date before setting visit times.',
      visitNeedBothTimes: 'Select both visit start and end times.',
      visitCascadeSeparator: ' / ',
      addressManualHint: 'Optional: enable address suggestions by setting VUE_APP_GOOGLE_MAPS_API_KEY for the frontend build.'
    },
    leadDetailPage: {
      convertOpp: 'Convert to opportunity',
      createProject: 'Create project',
      newQuote: 'New quote',
      openOpp: 'Open opportunity',
      tabBase: 'Overview',
      tabFollow: 'Follow-ups',
      tabNote: 'Internal notes',
      leadNo: 'Lead #',
      writeFollow: 'Log follow-up',
      addNote: 'Add note',
      followDialog: 'Follow-up',
      followTime: 'Follow-up time',
      followTimePh: 'Defaults to now if empty',
      followType: 'Type',
      followContent: 'Notes',
      followContentPh: 'Summary',
      nextAppt: 'Next appointment',
      projectFromLead: 'Create project from lead',
      projectHint: 'Requires a signed contract from this lead’s quote. The project will link to that contract.',
      pmLabel: 'Project manager',
      pmPh: 'Select project manager',
      projectName: 'Project name',
      create: 'Create',
      noteDialog: 'Internal note',
      needPm: 'Please select a project manager',
      needContent: 'Please enter content',
      needNote: 'Please enter a note',
      projectOk: 'Project created',
      projectFail: 'Failed (contract required first)',
      oppOk: 'Opportunity created',
      visitWindow: 'Visit window',
      gcalSynced: 'Synced to assigned rep and office calendars',
      gcalNotSynced: 'Not synced (owner not linked or OAuth missing)',
      nextApptInline: 'Next:',
      googleCalendar: 'Google Calendar',
      leadCostSection: 'Lead cost',
      leadCostHint:
        'Computed from the owner’s monthly sales (sum of contract totals for projects they own with created date in that month) and a tiered rate. Recalculate after projects or change orders change.',
      recalcLeadCost: 'Recalculate lead cost',
      leadCostAmount: 'Computed cost',
      leadCostOk: 'Lead cost updated'
    },
    customerFormPage: {
      editTitle: 'Edit customer',
      newTitle: 'New customer',
      newSubtitle: 'Primary contact and address for quotes (optional fields).',
      customerNo: 'Customer #',
      primaryContact: 'Primary contact',
      address: 'Address',
      addrLine1: 'Address line 1',
      addrLine2: 'Address line 2',
      city: 'City',
      state: 'State / province',
      zip: 'Postal code',
      country: 'Country',
      countryPh: 'e.g. US',
      notFound: 'Customer not found',
      sectionPrimaryContact: 'Primary contact',
      sectionAddress: 'Address',
      zipLabel: 'Postal code',
      salesOwner: 'Sales owner',
      salesOwnerPh: 'Select sales owner'
    },
    opportunityNewPage: {
      title: 'New opportunity',
      sub: 'Attach to an existing account or create a new account and opportunity in one step (no lead required).',
      customerSource: 'Account source',
      modeExisting: 'Existing account',
      modeNew: 'New account',
      customer: 'Account',
      customerSearchPh: 'Search by company or phone',
      companyName: 'Company name',
      contactFirst: 'Contact first name',
      contactLast: 'Contact last name',
      oppName: 'Opportunity name',
      initialStage: 'Initial stage',
      owner: 'Owner',
      ownerDefault: 'Defaults to me',
      submit: 'Create opportunity',
      ruleMode: 'Please select',
      ruleCustomer: 'Please select an account',
      ruleCompanyNew: 'Please enter company name',
      ruleOppName: 'Please enter opportunity name',
      created: 'Opportunity created',
      failed: 'Failed to create',
      pickExisting: 'Existing account',
      pickNew: 'New account',
      labelEmail: 'Email',
      labelPhone: 'Phone'
    },
    salesAmountPage: {
      cardTitle: 'Monthly sales amount',
      month: 'Month (yyyy-MM)',
      amount: 'Sales amount',
      salesperson: 'Salesperson',
      saved: 'Saved'
    },
    projectDetailPage: {
      recalc: 'Recalculate',
      recalcOk: 'Recalculated',
      saved: 'Saved',
      saveFailed: 'Save failed',
      deleteExpenseConfirm: 'Delete this expense record?',
      deletePaymentConfirm: 'Delete this receipt record?',
      deleteFail: 'Delete failed',
      uploadOk: 'Uploaded',
      uploadFail: 'Upload failed',
      projectCode: 'Project code',
      projectName: 'Project name',
      projectStatus: 'Status',
      contractNo: 'Contract #',
      customerName: 'Customer',
      customerPhone: 'Customer phone',
      customerEmail: 'Customer email',
      pm: 'Project manager',
      assignedSub: 'Assigned subcontractor',
      subcontractor: 'Subcontractor',
      subPlaceholder: 'Search and select',
      download: 'Download',
      attachmentDownloadUnavailable: 'This attachment cannot be downloaded from here.',
      expenseTitle: 'Expense',
      paymentTitle: 'Payment',
      receivePayment: 'Receive',
      payee: 'Payee',
      method: 'Method',
      remark: 'Remark',
      reference: 'Reference',
      paymentPlan: 'Payment plan',
      invoice: 'Invoice',
      attachmentCol: 'Open',
      changeOrderNo: 'Change no',
      planNodeName: 'Node',
      planPlannedAmt: 'Planned',
      planActualAmt: 'Actual',
      planPlannedDateCol: 'Planned date',
      planActualDateCol: 'Actual date',
      attFile: 'File',
      attSource: 'Source',
      attCreated: 'Created',
      invoiceNum: 'Invoice #{id}',
      expenseValidatePayee: 'Please enter payee.',
      expenseValidateAmount: 'Please enter a valid expense amount.',
      expenseValidateAmountPositive: 'Expense amount must be greater than zero.',
      expenseValidateDate: 'Please select expense date.',
      expenseValidateMethod: 'Please enter payment method.',
      paymentValidateAmount: 'Please enter a valid receipt amount.',
      paymentValidateAmountPositive: 'Receipt amount must be greater than zero.',
      paymentValidateDate: 'Please select receipt date.',
      paymentValidatePlan: 'Please select a payment plan node.',
      paymentValidateMethod: 'Please enter payment method.',
      paymentValidateReference: 'Please enter reference / transaction no.',
      supplementInvoice: 'Add invoice file',
      paymentInvoiceClickUpload: 'Click to upload invoice',
      paymentInvoiceClickDownload: 'Click to download invoice',
      invoiceAttached: 'Uploaded',
      invoiceNotAttached: 'Not uploaded',
      paymentSelectInvoiceFile: 'Please choose an invoice file to upload.',
      paymentInvoiceLinked: 'Invoice uploaded and linked.',
      paymentAlreadyHasInvoice: 'This receipt already has an invoice.',
      invoiceNoOptional: 'Invoice no.',
      paymentNewInvoiceSection: 'Invoice information',
      expenseKind: 'Expense category',
      expenseKindCol: 'Category',
      expenseTypeVendor: 'Vendor (procurement)',
      expenseTypeSubcontractor: 'Subcontractor',
      expenseTypeMisc: 'Other',
      payeeHint: 'Prefer company name; project name if needed.',
      selectVendor: 'Vendor',
      selectSubcontractorParty: 'Subcontractor',
      expenseValidateParty: 'Please select a vendor or subcontractor from the directory.',
      expenseValidatePartyName: 'The selected partner has no company or trade name; please update the partner record.',
      colAttachments: 'Attachments',
      expenseAttachmentListTitle: 'Expense attachments',
      expenseAttachmentListEmpty: 'No attachments for this expense.',
      paymentAttachmentListTitle: 'Receipt attachments',
      paymentAttachmentListEmpty: 'No attachments for this receipt.',
      uploadLinkedAttach: 'Attach',
      invoiceListTitle: 'Invoices (this project)',
      uploadMainInvoice: 'Upload main file',
      invoiceColNo: 'Invoice no.',
      invoiceMainFile: 'Invoice PDF',
      invoiceExtraFiles: 'Extra files',
      expenseOptionalAttachment: 'Attachments (optional)',
      paymentOptionalAttachment: 'Attachments (optional)',
      attachKind_custom: 'General',
      attachKind_invoice: 'Invoice (main file)',
      attachKind_invoiceAttach: 'Invoice (extra)',
      attachKind_contractSigned: 'Signed contract',
      attachKind_contractAttach: 'Contract (extra)',
      attachKind_quoteAttach: 'Quote (extra)',
      attachKind_expenseAttach: 'Expense',
      attachKind_paymentAttach: 'Receipt / payment',
      attachKind_changeOrder: 'Change order (file)',
      attachKind_changeOrderAttach: 'Change order (extra)'
    },
    opportunityDetailPage: {
      crumbOpp: 'Opportunity',
      backList: 'Back to list',
      save: 'Save changes',
      panelFields: 'Fields',
      panelRelated: 'Related',
      oppName: 'Opportunity name',
      stage: 'Stage',
      oppStatus: 'Opportunity status',
      amountUsd: 'Amount (USD)',
      winRate: 'Win %',
      closeDate: 'Close date',
      owner: 'Owner',
      ownerPh: 'Select sales owner',
      stageHint:
        'Saving applies default win rate for the stage (pipeline style). You can still adjust win % without changing stage.',
      newQuote: 'New quote',
      customerCompany: 'Account',
      contactPerson: 'Contact',
      email: 'Email',
      phone: 'Phone',
      noCustomer: 'No customer on file',
      leadSource: 'Source lead',
      leadLoading: 'Loading lead…',
      noLeadLinked: 'No linked lead (standalone opportunity)',
      relatedQuotes: 'Related quotes',
      quoteNo: 'Quote #',
      totalUsd: 'Total (USD)',
      quoteStage: 'Stage',
      createdAt: 'Created at',
      actions: 'Actions',
      edit: 'Edit',
      view: 'View',
      loadFailed: 'Failed to load',
      saved: 'Saved',
      saveFailed: 'Save failed'
    },
    quoteFormPage: {
      editTitle: 'Edit quote',
      newTitle: 'New quote',
      newSubtitle: 'Link a lead and enter customer info and line items.',
      lockedAlert:
        'This quote is locked (in approval, approved, or after sent). View from the list or use “Send quote”.',
      sectionBase: 'Basics',
      sectionLines: 'Line items',
      sectionAttachments: 'Attachments (this quote, on linked project)',
      attachEmpty: 'No extra files yet.',
      attachView: 'View',
      attachDownload: 'Download',
      lead: 'Lead',
      leadPh: 'Select lead',
      leadEmptyHint: 'No leads available. Create a lead first.',
      customerName: 'Customer name',
      firstNamePh: 'First name',
      lastNamePh: 'Last name',
      validUntil: 'Valid until',
      validUntilPh: 'Quote valid through',
      linesHint: 'Amounts in USD; enter name, qty, unit price and markup % per line.',
      addLine: 'Add line',
      colName: 'Name',
      colProduct: 'Product',
      colDescription: 'Description',
      colQty: 'Qty',
      colUnitUsd: 'Unit (USD)',
      colTaxPct: 'Markup %',
      colLineTotal: 'Line total',
      removeLine: 'Remove',
      estimatedTotal: 'Estimated total:',
      save: 'Save',
      saveDraft: 'Save draft',
      deleteDraft: 'Delete draft',
      confirmDeleteDraft: 'Delete this quote draft? This cannot be undone.',
      deletedDraft: 'Draft deleted',
      deleteDraftFailed: 'Could not delete draft',
      saveSubmitApproval: 'Save & submit for approval',
      createContractFromQuote: 'Create contract from this quote',
      back: 'Back',
      needLead: 'Please select a lead',
      needValidUntil: 'Please select a valid until date',
      loadLeadFailed: 'Failed to load leads',
      saved: 'Saved',
      created: 'Created',
      failed: 'Something went wrong',
      submittedApproval: 'Saved and submitted for internal approval',
      leadNum: 'Lead #{id}',
      lineItemPh: 'Line item name',
      descriptionPh: 'Line notes for this quote only (optional; does not change the product master)',
      productPh: 'Select product',
      productNum: 'Product #{id}',
      legacyLineItem: 'Saved item: ',
      loadProductsFailed: 'Failed to load products',
      addNewProduct: '＋ New product…',
      sectionPaymentPlan: 'Payment schedule',
      paymentPlanHint: 'Optional milestones for customer collections (shown on the shared quote and merged into the contract).',
      addPlanNode: 'Add milestone',
      emptyPaymentPlans: 'No payment milestones yet.',
      colPlanNode: 'Milestone',
      colPlanAmount: 'Amount (USD)',
      colPlanDate: 'Due date',
      colPlanRemark: 'Notes',
      planNodePh: 'e.g. Deposit',
      planAmountPh: '0.00',
      planDatePh: 'Due date',
      planPlannedTotal: 'Scheduled total:',
      planUnplanned: 'Unallocated:'
    },
    contractTemplateFormPage: {
      editTitle: 'Edit Contract Template',
      newTitle: 'Create New Contract Template',
      newSubtitle:
        'Enter the name and version, then compose the HTML body below; merge placeholders populate when generating contracts.',
      newTip:
        'Saving creates the template record. Use standard HTML plus merge placeholders; PDF output is rendered on the server.',
      name: 'Name',
      namePh: 'e.g. Standard construction agreement',
      version: 'Version',
      versionPh: 'e.g. v1.0, 2026Q1',
      fileWhenNew: 'Template file',
      fileWhenEdit: 'Upload file',
      chooseFile: 'Choose file',
      chooseFileUpload: 'Choose file & upload',
      pendingChosen: 'Selected {name} (uploads on save)',
      preview: 'Preview',
      uploadedBadge: 'Uploaded',
      uploadHint:
        'Only .docx is supported. You may save name/version only and upload later from edit. Preview downloads for local opening in Word.',
      save: 'Save',
      backList: 'Back to list',
      ruleRequired: 'Required',
      notFound: 'Record not found',
      loadFailed: 'Load failed',
      saved: 'Saved',
      created: 'Created',
      createdWithUpload: 'Created and file uploaded',
      createUploadWarn: 'Template created but file upload failed — open edit to upload again.',
      failed: 'Failed',
      uploaded: 'Uploaded',
      uploadFail: 'Upload failed',
      previewFail: 'Preview failed',
      pageSizeLabel: 'Page size',
      pageMarginsLabel: 'Page margins (mm)',
      pageMarginsPlaceholder: 'top right bottom left, e.g. 20 20 20 20',
      pageSizeLetter: 'US Letter',
      pageSizeA4: 'A4',
      pageSizeLegal: 'Legal',
      insertPlaceholderLabel: 'Insert placeholder',
      insertPlaceholderPh: 'Pick a placeholder to insert',
      viewAllPlaceholders: 'View all placeholders',
      htmlBodyLabel: 'HTML body',
      htmlBodyPh: '<h1>Service Agreement</h1>\n\nContract No. {{contract_no}}\n\n<p>...</p>',
      htmlBodyTipPrefix: 'Tip: use standard HTML tags. Placeholders like ',
      htmlBodyTipSuffix: ' will be replaced at contract generation time.',
      livePreviewLabel: 'Live preview',
      livePreviewHint:
        'Preview shows PDF layout. Signature blocks and payment-plan placeholders show table structure only.',
      legacyDocxHint:
        'This template was previously DOCX-only; replace the HTML body below and save. New contracts use PDF generated from HTML only.',
      placeholderDialogTitle: 'Merge placeholders',
      phColPlaceholder: 'Placeholder',
      phColDescription: 'Description',
      phColActions: 'Actions',
      copyPlaceholder: 'Copy',
      copiedToClipboard: 'Placeholder copied to clipboard.',
      htmlBodyRequired: 'HTML body is required.',
      previewCustomerSignature: 'Customer Signature',
      previewCompanySignature: 'Company Signature',
      previewSignatureHint: 'Awaiting signature',
      previewPlanColIndex: '#',
      previewPlanColMilestone: 'Milestone',
      previewPlanColAmount: 'Amount (USD)',
      previewPlanColDue: 'Due date',
      previewPlanColNotes: 'Notes',
      previewPlanBanner: 'Template placeholder — replaced with the quote payment schedule when a contract is generated',
      previewPlanTextBanner: 'Template placeholder — replaced with quote payment schedule (plain text)',
      previewPlanEmptyHint: 'Rows come from the linked quote; they are not stored in this template',
      previewPlanTextEmptyHint: 'Quote payment schedule (plain text) will appear here',
      sampleHtmlBody:
        '<h1>Service Agreement</h1>\n' +
        '<p style="color:#6b7280;">Contract No. {{contract_no}} &middot; {{contract_title}}</p>\n\n' +
        '<h3>Parties</h3>\n' +
        '<p>This Agreement is entered into between <strong>EHD Builders</strong> and\n' +
        '<strong>{{customer_contact_name}}</strong> ({{customer_email}}).</p>\n\n' +
        '<h3>Term</h3>\n' +
        '<p>Effective {{contract_start_date}} through {{contract_end_date}} ({{contract_term_months}} months).</p>\n\n' +
        '<h3>Consideration</h3>\n' +
        '<p>Total contract amount: <strong>{{quote_total_amount_fmt}} {{currency_code}}</strong>\n' +
        '(Quote #{{quote_no}}).</p>\n\n' +
        '<h3>Payment Schedule</h3>\n' +
        '{{payment_plan_table}}\n\n' +
        '<h3>Signatures</h3>\n' +
        '<p>By signing below, the parties acknowledge and agree to the terms of this Agreement.</p>\n' +
        '<table style="width:100%;border-collapse:collapse;margin-top:14pt;"><tr>\n' +
        '<td style="width:50%;padding-right:18pt;vertical-align:top;">{{customer_signature}}</td>\n' +
        '<td style="width:50%;padding-left:18pt;vertical-align:top;">{{company_signature}}</td>\n' +
        '</tr></table>'
    },
    systemOverviewPage: {
      users: 'Users',
      roles: 'Roles',
      menus: 'Menus',
      oauth: 'OAuth',
      ready: 'Ready',
      missing: 'Missing'
    },
    subcontractorFormPage: {
      editTitle: 'Edit partner',
      newTitle: 'New partner',
      newSubtitle: 'Suppliers (procurement) and subcontractors share one directory; set type for expense filters.',
      partyType: 'Partner type',
      sectionMain: 'Business',
      sectionLicense: 'License & contact',
      companyLegal: 'Legal company name',
      companyLegalPh: 'Registered name (optional)',
      tradeName: 'Trade name',
      tradeNamePh: 'Name used in the field',
      contact: 'Contact',
      contactPh: 'Contact person',
      licenseNo: 'License #',
      licensePh: 'License or registration #',
      insurance: 'Insurance',
      insurancePh: 'Policy notes',
      phonePh: 'Phone',
      emailPh: 'Email',
      notFound: 'Record not found',
      saved: 'Saved',
      created: 'Created',
      failed: 'Failed',
      ruleName: 'Required'
    },
    productFormPage: {
      editTitle: 'Edit product',
      newTitle: 'New product',
      newSubtitle: 'Products are maintained by office users and selected when creating quote line items.',
      productName: 'Product name',
      productNamePh: 'e.g. Standard cabinet installation',
      productCode: 'Product code',
      productCodePh: 'Optional SKU or internal code',
      unitPrice: 'Unit price',
      unitPricePh: 'USD',
      description: 'Description',
      descriptionPh: 'Catalog description; copied to the quote line when this product is selected (editable per quote)',
      notFound: 'Product not found',
      saved: 'Saved',
      created: 'Created',
      failed: 'Failed',
      ruleName: 'Please enter product name',
      ruleUnitPrice: 'Please enter a valid unit price'
    },
    contractFromQuotePage: {
      title: 'Create contract from quote',
      subtitle: 'Only customer-approved quotes; amounts match the quote snapshot with term dates.',
      quoteSummary: 'Selected quote',
      selectQuote: 'Select quote',
      quotePh: 'Choose a quote',
      quoteNo: 'Quote #',
      lead: 'Lead',
      customer: 'Customer',
      quoteAmount: 'Quote amount',
      status: 'Status',
      existingContract: 'Existing contract',
      viewContract: 'View #',
      template: 'Contract template',
      templatePh: 'Template (optional)',
      contractTitle: 'Contract title',
      titlePh: 'Default: lead · quote #',
      startDate: 'Start date',
      startPh: 'Pick start date',
      scheduleBlockLabel: 'Dates & term',
      termMonths: 'Term',
      termOrEnd: 'Term or end date',
      termByMonths: 'By months',
      termByEndDate: 'End date',
      monthsHintShort: 'End date = start + term (months).',
      endDateHint: 'Must be on or after the start date.',
      needEndDate: 'Please select an end date.',
      orEndDate: 'Or end date',
      submit: 'Create contract',
      endPh: 'End date',
      submitOpenDetail: 'Create and open detail',
      loadQuotesFailed: 'Failed to load quotes',
      loadContextFailed: 'Load failed',
      selectQuoteWarning: 'Pick an eligible quote (customer-approved, no contract yet)',
      quoteNum: 'Quote #{id}',
      templatePhLong: 'Saved template (optional)',
      failed: 'Failed to create contract'
    },
    contractDetailPage: {
      backList: 'Back to list',
      defaultTitle: 'Contract detail',
      changeOrdersThis: 'Change orders',
      tabBase: 'Overview',
      tabChangeOrders: 'Change orders',
      tabPlans: 'Payment plan',
      tabInvoices: 'Invoices',
      changeOrdersAllNav: 'Open full change-order list',
      quoteNo: 'Quote #',
      template: 'Template',
      linkedProject: 'Linked project',
      projectHash: 'Project #',
      linkedProjectFallback: 'Project #{id}',
      quoteSnapshot: 'Quote amount',
      startDate: 'Start date',
      endDate: 'End date',
      termMonths: 'Term (months)',
      signer: 'Customer signer',
      signedAt: 'Signed at',
      signEmail: 'Signer email',
      signIp: 'Signer IP',
      createdAt: 'Created at',
      mergedDoc: 'Merged document',
      noMergedTip: 'No merged file: no template at creation or template file missing.',
      downloadMerged: 'Download merged',
      viewMergedDoc: 'View merged',
      remerge: 'Regenerate merge',
      signedFile: 'Signed file',
      signedFileTip: 'Upload signed scan/PDF; download to verify archive.',
      signedFileUploadedLabel: 'Uploaded file',
      signedFileNameUnknown: 'Name not recorded (upload before this update)',
      uploadSigned: 'Choose file & upload',
      downloadSigned: 'Download signed file',
      viewSignedDoc: 'View signed file',
      publicLink: 'Customer public link',
      publicLinkTip: 'Public page for view, download and signature.',
      copyContractLink: 'Copy contract link',
      openPublic: 'Open public page',
      openEsignTrail: 'E-sign audit',
      docsActionsTitle: 'Documents, signed upload & audit',
      esignFlowTitle: 'E-sign workflow (DocuSign-style)',
      esignStepDraft: 'Draft ready',
      esignStepSent: 'Sent to customer',
      esignStepCustomer: 'Customer signed',
      esignStepCompany: 'Company signed',
      esignStepFinal: 'Final sent',
      esignLegacy: 'Not using the ordered workflow',
      esignRecipientPh: 'Customer email (optional if stored on customer)',
      sendInvite: 'Email signing invite',
      companySign: 'Company sign',
      sendFinal: 'Email final to customer',
      archiveFlow: 'Archive contract',
      downloadCustomerSigned: 'Download customer-signed copy',
      downloadFullExecuted: 'Download fully-executed copy',
      downloadSignedPackage: 'Download signed PDF',
      signedPreviewCustomer: 'Customer-signed contract',
      signedPreviewBoth: 'Fully-executed contract',
      signedPdfLoading: 'Loading contract…',
      contractPreviewDraft: 'Contract document',
      showContractPreview: 'Preview contract',
      hideContractPreview: 'Hide preview',
      downloadContractDoc: 'Download',
      contractPreviewCollapsedHint: 'Click "Preview contract" above to view the document here.',
      remergeConfirm: 'Regenerate the merged contract from the current quote and template? Use this after updating contract fields before sending to the customer.',
      companySignerName: 'Signer name',
      companySignerNameRequired: 'Please enter the company signer name',
      companySignTitle: 'Company e-signature',
      archivePickFile: 'Optional file for archive',
      esignInviteSent: 'Invite email sent',
      esignFinalSent: 'Final email sent',
      esignArchived: 'Contract archived',
      esignWrongState: 'This action is not available at the current step',
      esignTrail: 'E-sign audit',
      esignSigner: 'Signer',
      esignEmail: 'Email',
      esignTime: 'Time',
      esignIp: 'IP',
      esignUa: 'Device',
      esignNote: 'Note',
      downloadSigImg: 'Download signature image',
      auditEvent: 'Event',
      auditTime: 'Time',
      auditSigner: 'Signer',
      auditEmail: 'Email',
      auditIp: 'IP',
      auditRemark: 'Remark',
      auditUa: 'Device',
      toProject: 'Create project',
      openProject: 'Open project',
      toProjectDlgHint:
        'Select a project manager. Project name defaults to the quote customer name; you can edit it before saving.',
      linkedOkTip: 'Project linked — open it above for payment plan, invoices, and more.',
      pmLabel: 'Project manager',
      pmPh: 'Select PM',
      pjName: 'Project name',
      pjNamePh: 'Defaults to customer name from quote; editable',
      createProject: 'Create project',
      planHint: 'Record planned/actual amounts per node for collections summary.',
      planHintContract: 'Maintain payment milestones on this contract. Actual collections are tracked after a project is linked.',
      planStatContractAmt: 'Contract amount',
      planStatContractAmtTip: 'Quote snapshot plus approved change orders.',
      planStatPlannedTotal: 'Planned payments',
      planStatUnplanned: 'Remaining to plan',
      planStatUnplannedTip: 'Contract amount minus sum of planned node amounts (not below zero).',
      addPlanNode: 'Add payment node',
      emptyPlans: 'No nodes yet — add above',
      nodeCol: 'Node',
      plannedAmt: 'Planned',
      plannedDate: 'Planned date',
      actualAmt: 'Actual',
      actualDate: 'Actual date',
      emptyNeedProject: 'Create a linked project under Overview first.',
      registerInvoice: 'Register invoice',
      emptyInvoices: 'No invoices yet',
      invNo: 'Invoice #',
      invType: 'Type',
      invAmt: 'Amount',
      invDate: 'Invoice date',
      uploadFile: 'Upload file',
      customerLink: 'Customer link',
      emptyInvNeedProj: 'Create linked project before invoices.',
      editPlanTitle: 'Edit payment node',
      nodeName: 'Node name',
      planAmt: 'Planned amount',
      planAmtPh: 'USD',
      planDatePh: 'Optional',
      actualAmtPh: 'Received amount',
      statusPh: 'Status',
      invRegisterTitle: 'Register invoice',
      invAmtUsd: 'Amount (USD)',
      auditViewed: 'Viewed',
      auditDownloaded: 'Downloaded',
      auditSigned: 'Signed',
      auditSentInvite: 'Invite email sent',
      auditCompanySigned: 'Company signed',
      auditFinalEmail: 'Final email sent',
      auditArchived: 'Archived',
      auditUnknown: 'Unknown',
      showViewAudits: 'Show “viewed” rows',
      auditViewHiddenHint: '{count} “viewed” row(s) hidden — check the option above to show them.',
      auditTableEmptyFiltered: 'Only “viewed” rows are loaded; enable “Show viewed rows” above.',
      loadPmFailed: 'Failed to load users',
      signedUploaded: 'Signed file uploaded',
      mergeRegenerated: 'Merged file regenerated',
      noSignedFile: 'No signed file uploaded',
      noSignatureImg: 'No signature image',
      selectPmWarn: 'Please select a project manager',
      defaultProjectName: 'Project',
      defaultNodePrefix: 'Node',
      deletePlanConfirm: 'Delete this payment node?',
      deleted: 'Deleted',
      planSaved: 'Saved',
      invoiceRegistered: 'Registered',
      invoiceUploaded: 'Uploaded',
      extraQuoteContractFiles: 'Extra files (quote & contract)',
      extraQuoteContractTip: 'Supplementary uploads linked to this contract’s quote and contract record on the linked project workspace.',
      quoteExtraSection: 'Quote',
      contractExtraSection: 'Contract',
      extraAttachEmpty: 'No extra files yet',
      downloadExtraAttach: 'Download',
      previewExtraAttach: 'View',
      invoiceLinkCopied: 'Invoice public link copied',
      copyContractOk: 'Contract public link copied',
      projectCreated: 'Project created',
      saveFail: 'Save failed',
      actionFail: 'Action failed',
      planMutateOnlyPlanning: 'Only nodes in “Planning” status can be edited or deleted.',
      planValidateNodeName: 'Node name is required.',
      planValidatePlannedAmount: 'Planned amount is required and must be a number.',
      planValidatePlannedDate: 'Planned date is required.'
    },
    mergeDialog: {
      title: 'Merge field reference',
      intro: 'Use these placeholders in .docx templates.',
      dialogTitle: 'Contract template placeholders',
      colWrite: 'Placeholder (copy as-is)',
      colMerge: 'Resolves to',
      gotIt: 'OK',
      note: 'Customers receive merged Word/HTML only. The table is for internal authors. In the body use double curly braces, e.g. {{quote_no}}.',
      placeholders: {
        contract_no: 'Contract number',
        contract_title: 'Contract title',
        contract_start_date: 'Contract start date (yyyy-MM-dd)',
        contract_end_date: 'Contract end date (yyyy-MM-dd)',
        contract_term_months: 'Contract term (months)',
        contract_created_date: 'Contract record creation date (yyyy-MM-dd)',
        contract_created_at: 'Contract record creation time (ISO)',
        contract_creator_name: 'Created-by name (system user)',
        quote_no: 'Quote number',
        quote_total_amount: 'Quote total (numeric)',
        quote_total_amount_fmt: 'Quote total (with thousands separators & two decimals)',
        currency_code: 'Currency code (e.g. USD)',
        quote_valid_until: 'Quote valid-until date (yyyy-MM-dd)',
        opportunity_no: 'Lead number',
        opportunity_name: 'Lead display name (contact)',
        opportunity_amount: 'Quote total (numeric)',
        opportunity_amount_fmt: 'Quote total (formatted with decimals)',
        opportunity_close_date: 'Reserved (close date)',
        opportunity_probability: 'Reserved (win probability)',
        opportunity_owner_name: 'Lead owner (sales) name',
        customer_no: 'Customer number',
        customer_company_name: 'Legacy: primary contact full name (same as customer_contact_name)',
        customer_first_name: 'Customer first name',
        customer_last_name: 'Customer last name',
        customer_contact_name: 'Customer contact full name',
        customer_email: 'Customer email',
        customer_phone: 'Customer phone',
        customer_address_line1: 'Address line 1',
        customer_address_line2: 'Address line 2',
        customer_city: 'City',
        customer_state: 'State/province code',
        customer_zip: 'Postal/ZIP code',
        customer_country: 'Country code',
        customer_address_full: 'Full address (single line)',
        template_name: 'Selected template name',
        template_version: 'Template version tag',
        today: 'Merge generation date (yyyy-MM-dd)',
        project_code: 'Linked project code (empty if none)',
        project_name: 'Linked project name (empty if none)',
        payment_plan_table: 'Payment schedule HTML table (from quote; insert in HTML templates)',
        payment_plan_text: 'Payment schedule plain-text list (for Word templates)',
        customer_signature: 'Customer signature block (empty box on draft; renders the signature image after the customer signs)',
        company_signature: 'Company signature block (empty box on draft; renders the signature image after EHD signs)'
      }
    },
    dashboardExtra: {
      pipelineSubtitle: 'Track deals from lead to cash in one pipeline.'
    },
    dashboardPage: {
      title: 'Sales Workbench',
      subtitle: 'Monitor approvals, signatures, finance and schedule in one place.',
      kpiNewLeads: 'New leads this week',
      kpiLeadsStats: 'Leads created',
      kpiLeadsWeek: 'Week',
      kpiLeadsMonth: 'Month',
      kpiLeadsYear: 'Year',
      kpiQuotesPending: 'Quotes pending approval',
      kpiContractsAwaiting: 'Contracts awaiting signature',
      kpiSignedValue: 'Signed contract value (MTD)',
      pipelineTitle: 'Pipeline conversion',
      tasksTitle: 'My to-do list',
      actionsTitle: 'Quick actions',
      recentTitle: 'Recent activity',
      calendarTitle: 'Google Calendar integration',
      calendarConnected: 'Connected',
      calendarDisconnected: 'Not connected',
      calendarSummary: 'Primary calendar',
      connectCalendar: 'Connect Google Calendar',
      disconnectCalendar: 'Disconnect',
      gotoLeads: 'New lead',
      gotoQuote: 'New quote',
      gotoSchedule: 'My schedule',
      gotoContracts: 'Contracts',
      gotoReports: 'Reports',
      gotoFinance: 'Finance center',
      gotoSalesPersonReport: 'Salesperson report',
      statLeadsMtd: 'Leads MTD',
      statContractsMtd: 'Contracts MTD',
      statConversion: 'Conversion',
      taskCountItems: '{count} items',
      calendarLeadSyncHint:
        'Lead visit events sync to the assigned rep and all office users who connected Google Calendar. CRM changes can be written back to Google.',
      redirectingOAuth: 'Redirecting…',
      disconnectingOAuth: 'Disconnecting…',
      googleConnectedToast: 'Google Calendar connected',
      googleAuthErrorPrefix: 'Google authorization failed:',
      googleAuthUnknownReason: 'Unknown error',
      oauthCannotStart: 'Cannot start OAuth',
      noAuthUrlReturned: 'No authorization URL returned',
      disconnectGoogleConfirm: 'Disconnect Google Calendar for this user?',
      disconnectGoogleTitle: 'Confirm',
      disconnectedToast: 'Disconnected',
      disconnectFailed: 'Failed to disconnect',
      salesReportCardTitle: 'Salesperson report',
      salesReportColSales: 'Salesperson',
      salesReportColQuotes: 'Quotes pending',
      salesReportColContracts: 'Contracts pending',
      salesReportColActions: 'Actions',
      salesReportViewDetail: 'Details',
      salesReportSalesHint:
        'You have {q} quote(s) pending internal approval and {c} contract(s) awaiting signature. Open the full report to export detail.',
      salesReportOpenFull: 'Open full report'
    },
    schedulePage: {
      title: 'My schedule',
      calendarPanel: 'Calendar',
      subtitle: 'Lead visits from CRM; connect Google Calendar on Home to sync to your personal calendar.',
      upcoming: 'Upcoming visits',
      monthEvents: 'Visits this month',
      prev: 'Prev',
      next: 'Next',
      syncedLead: 'Lead visit',
      notConnected: 'Google Calendar is not connected yet.',
      emptyEventsMonth: 'No visits scheduled this month',
      colEventStart: 'Start',
      colEventEnd: 'End',
      colEventTitle: 'Title',
      colAssignedSales: 'Sales rep',
      openLead: 'Lead',
      openInGoogle: 'Google',
      noEventTitle: '(No title)',
      loadFailed: 'Failed to load schedule',
      connectGoogle: 'Connect Google Calendar',
      hintSelfGoogle:
        'You have not connected Google Calendar yet. Visits still appear here; after connecting, they will sync to your Google Calendar.',
      hintOfficePendingGoogle:
        'The following office users have not connected Google Calendar. After they connect, past and future visits will sync automatically: {names}'
    },
    reportPage: {
      title: 'Analytics & reports',
      subtitle: 'Track pipeline conversion, signed revenue, collections, expense and profitability.',
      pipeline: 'Lead pipeline',
      finance: 'Project finance',
      exportLead: 'Export leads',
      exportProject: 'Export project finance',
      latestProjects: 'Latest projects',
      projectFinanceSnapshot: 'Project finance snapshot',
      pipeQuoteAmount: 'Quote amount',
      pipeContractAmount: 'Contract amount',
      tableProjectCode: 'Project code',
      tableProjectName: 'Project name',
      tableRevenue: 'Contract total',
      tableExpense: 'Expense',
      tableProfit: 'Profit',
      leadChartTitle: 'Lead status distribution',
      financeReceived: 'Received'
    },
    salesPersonReportPage: {
      title: 'Salesperson report',
      subtitle: 'Filter by rep, preview detail, and export multi-sheet Excel.',
      export: 'Export Excel',
      salesperson: 'Salesperson',
      allSales: 'All sales',
      onlyUnassigned: 'Unassigned leads only',
      scopeLabel: 'Scope',
      sectionLeads: 'Leads in date range',
      sectionPendingQuotes: 'Quotes pending internal approval (current)',
      sectionPendingContracts: 'Contracts awaiting signature (current)',
      sectionSignedContracts: 'Signed contracts in date range',
      colSales: 'Salesperson',
      colLeadNo: 'Lead no.',
      colFirstName: 'First name',
      colLastName: 'Last name',
      colEmail: 'Email',
      colStatus: 'Lead status',
      colCreatedAt: 'Created at',
      colQuoteNo: 'Quote no.',
      colQuoteStatus: 'Quote status',
      colUpdatedAt: 'Updated at',
      colContractNo: 'Contract no.',
      colContractStatus: 'Contract status',
      colSignedAt: 'Signed at',
      colSignedValueUsd: 'Signed value (USD)'
    },
    leadCostMonthPage: {
      title: 'Lead cost (monthly)',
      subtitle:
        'Monthly sales = for each owner, sum of project contract totals (quote snapshot + approved change orders) for projects assigned to them whose created date falls in that calendar month. ≤ 140,000 → 20%; > 140,000 → 15%. One row per lead per month. The server also auto-recalculates the current calendar month daily (configurable).',
      periodMonth: 'Month (yyyy-MM)',
      recalcMonth: 'Recalculate all for this month',
      recalcRow: 'Recalculate',
      colLead: 'Lead',
      colOwner: 'Assigned owner',
      colMonthlySales: 'Monthly sales (contract sum)',
      colCost: 'Lead cost',
      colRatio: 'Rate applied',
      colComputed: 'Last computed at',
      goProjectList: 'Open projects',
      doneBatch: 'Batch recalculation completed'
    },
    financeCenterPage: {
      leadCostNav: 'Lead cost (monthly)',
      overviewTotalContract: 'Total project contract amount',
      operatingExpenseHint: 'Expenses',
      totalLeadCostHint: 'Lead cost',
      colContractTotal: 'Total contract amount',
      colTotalExpense: 'Total expenses'
    },
    projectPage: {
      title: 'Project workspace',
      subtitle: 'Manage project financials, documents, payment plans and profit snapshot.',
      overview: 'Overview',
      financials: 'Financials',
      documents: 'Documents',
      activity: 'Activity',
      summary: 'Financial summary',
      totalSales: 'Total sales amount',
      contractAmount: 'Contract amount',
      originalContractAmount: 'Original contract amount',
      changeOrderAmountApproved: 'Change orders (approved)',
      contractAmountTotal: 'Total contract amount',
      totalReceived: 'Total received',
      totalBalance: 'Total balance due',
      totalExpense: 'Total expenses',
      operationalExpense: 'Expenses',
      profit: 'Profit',
      profitMargin: 'Profit margin',
      pmCommission: 'Project manager commission',
      leadCost: 'Lead cost',
      miscExpense: 'Misc expense',
      projectExpense: 'Project expense ledger',
      changeOrders: 'Change orders',
      paymentPlan: 'Payment plan',
      paymentRecords: 'Payment records',
      expenses: 'Expenses',
      attachments: 'Attachments'
    },
    publicQuote: {
      title: 'Quote review',
      subtitle: 'Review quote details and submit your decision online.',
      statusChipViewed: 'Please review and decide',
      notSentYet: 'This quote has not been sent to you yet.',
      decisionUnavailable: 'A decision cannot be submitted for the current status.',
      approve: 'Approve',
      reject: 'Reject',
      accept: 'Accept',
      decline: 'Decline',
      comment: 'Comment (optional)',
      submitted: 'Decision submitted',
      accepted: 'You already approved this quote.',
      rejected: 'You already rejected this quote.',
      total: 'Total',
      estimateTotal: 'Estimate total',
      viewEstimate: 'View estimate',
      summaryModeIntro: 'To move forward with this estimate, select Accept and EHD Builders will reach out with next steps.',
      detailModeIntro: 'Review the line items in the breakdown. To move forward, select Accept and EHD Builders will reach out with next steps.',
      detailModeIntroCollapsed:
        'Tap “View estimate” to open the full line-item breakdown. To move forward, select Accept and EHD Builders will reach out with next steps.',
      hideEstimate: 'Hide breakdown',
      docTitle: 'Estimate',
      docBillTo: 'Bill to',
      docEstimateNo: 'Estimate no.',
      docValidThrough: 'Valid through',
      docTotal: 'Total',
      celebrationTitle: 'Awesome!',
      celebrationSubtitle: 'You accepted this estimate.',
      celebrationNext: "We've let EHD Builders know you accepted. They'll reach out with next steps.",
      celebrationMetaBusiness: 'Business',
      celebrationMetaAccepted: 'Accepted on',
      celebrationMetaTotal: 'Estimate total',
      detailsTitle: 'Line items',
      colIndex: '#',
      colProduct: 'Product or service',
      colDescription: 'Description',
      noDetails: 'No quote details yet.',
      colItem: 'Item',
      colQty: 'Qty',
      colUnitPrice: 'Unit price',
      colAmount: 'Amount',
      paymentPlanTitle: 'Payment schedule',
      colPlanNode: 'Milestone',
      colPlanDate: 'Due date',
      planTotal: 'Scheduled total'
    },
    publicContract: {
      title: 'Contract review',
      subtitle: 'Review contract terms and confirm signature online.',
      sign: 'Confirm signature',
      signerName: 'Signer name',
      signerEmail: 'Signer email',
      note: 'Note',
      signed: 'Contract confirmed',
      download: 'Download contract',
      downloadNotReady: 'The contract file is not ready yet.',
      downloadNotReadyHint:
        'Once your provider generates the merged contract document in the CRM, download will be available here.',
      signUnavailableNoFile:
        'The contract file has not been generated yet, so online signing is not available. Please ask your provider to generate the document in the CRM first.',
      signUnavailableArchived: 'This contract is archived or cancelled; online signing is not available.',
      signUnavailableWrongStep:
        'The workflow is not at the customer-sign step yet. Please use the link from the email invite when ready.',
      status: 'Status',
      contract: 'Contract',
      startDate: 'Start date',
      endDate: 'End date',
      term: 'Term',
      amount: 'Amount',
      signedByCustomer: 'Signed by customer',
      signedAt: 'Signed at',
      contractItems: 'Contract items',
      item: 'Item',
      description: 'Description',
      qty: 'Qty',
      signature: 'Signature',
      clear: 'Clear',
      signHere: 'Sign here',
      submitFailed: 'Submit failed',
      loadFailed: 'Unable to load contract',
      alreadyCompleted: 'This contract is already completed or unavailable for online signing.',
      signRequired: 'Please sign before submitting'
    },
    publicInvoice: {
      title: 'Invoice view',
      subtitle: 'Review invoice details and download the invoice file.',
      download: 'Download invoice',
      amountHead: 'Amount',
      labelInvoiceNo: 'Invoice no',
      labelDate: 'Date',
      labelProject: 'Project',
      projectChip: 'Project',
      invoiceNum: 'Invoice #{id}'
    },
    emailConfigPage: {
      subtitle: 'Configure your SMTP sender for quote share emails.',
      intro:
        'Quote “Send quote” uses your SMTP below. This entry is managed in Menu admin (assign “Email configuration” to roles). Port 587 usually enables STARTTLS; port 465 often uses SSL. Leave “Public link base URL” empty to use the server default.',
      smtpHost: 'SMTP host',
      smtpHostPh: 'e.g. smtp.gmail.com',
      smtpHostRequired: 'SMTP host is required',
      smtpPort: 'SMTP port',
      smtpPortRequired: 'Port is required',
      smtpUsername: 'SMTP username',
      smtpUsernamePh: 'Often your full email address',
      smtpUsernameRequired: 'SMTP username is required',
      smtpPassword: 'SMTP password',
      passwordPh: 'App password or account password',
      passwordKeep: 'Leave blank to keep the saved password',
      passwordRequired: 'Password is required on first save',
      fromEmail: 'From address',
      fromEmailPh: 'Optional; defaults to SMTP username',
      fromPersonal: 'From display name',
      fromPersonalPh: 'Optional',
      ssl: 'SSL',
      sslOn: 'SSL (e.g. 465)',
      starttls: 'STARTTLS',
      starttlsOn: 'STARTTLS (e.g. 587)',
      publicBase: 'Public link base URL',
      publicBasePh: 'e.g. http://localhost:8080 — must match how clients open the app',
      save: 'Save',
      saveOk: 'Saved',
      saveFail: 'Save failed',
      loadFail: 'Failed to load settings'
    },
    settingsPage: {
      title: 'Settings center',
      subtitle: 'Manage users, roles, menu permissions, templates and integrations.'
    },
    enum: {
      unknown: 'Unknown ({value})',
      quoteStatus: {
        1: 'Draft',
        2: 'Internally approved',
        3: 'Internally rejected',
        4: 'Sent',
        7: 'Viewed — pending client decision',
        5: 'Client approved',
        6: 'Client rejected'
      },
      quoteInternalApproval: {
        0: 'Not submitted',
        1: 'Pending approval',
        2: 'Internally approved',
        3: 'Rejected'
      },
      quoteCustomerDecision: {
        1: 'Pending',
        2: 'Client approved',
        3: 'Rejected'
      },
      contractStatus: {
        1: 'Draft',
        2: 'Uploaded',
        3: 'Signed',
        4: 'Archived',
        5: 'Cancelled'
      },
      templateStatus: {
        1: 'Enabled',
        2: 'Disabled'
      },
      paymentPlanStatus: {
        1: 'Planned',
        2: 'Invoiced',
        3: 'Paid'
      },
      changeOrderApproval: {
        1: 'Draft',
        2: 'Submitted',
        3: 'Approved',
        4: 'Rejected'
      },
      invoiceType: {
        1: 'Standard',
        2: 'Change order'
      },
      projectStatus: {
        1: 'Planned',
        2: 'In progress',
        3: 'Completed',
        4: 'Cancelled'
      },
      leadStatus: {
        1: 'New',
        2: 'In follow-up',
        3: 'Qualified',
        4: 'Converted',
        5: 'Lost'
      },
      opportunityStage: {
        1: 'Discovery',
        2: 'Solution',
        3: 'Quote',
        4: 'Negotiation',
        5: 'Won',
        6: 'Lost'
      },
      customerStatus: {
        1: 'Active',
        2: 'Inactive'
      },
      opportunityStatus: {
        1: 'Open',
        2: 'Won',
        3: 'Lost'
      },
      invoiceStatus: {
        1: 'Uploaded',
        2: 'Confirmed'
      },
      followupType: {
        1: 'Call',
        2: 'Meeting',
        3: 'Email',
        4: 'Other',
        5: 'Visit'
      },
      subcontractorParty: {
        1: 'Supplier (procurement)',
        2: 'Subcontractor',
        3: 'Both'
      },
      productStatus: {
        1: 'Enabled',
        2: 'Disabled'
      }
    }
  },
  'zh-CN': {
    app: {
      name: 'EHD Builders CRM',
      tagline: '销售、合同、项目与财务统一工作台。'
    },
    common: {
      dashboard: '仪表盘',
      workbench: '工作台',
      back: '返回',
      save: '保存',
      cancel: '取消',
      search: '搜索',
      reset: '重置',
      refresh: '刷新',
      create: '新建',
      edit: '编辑',
      delete: '删除',
      download: '下载',
      upload: '上传',
      export: '导出',
      overview: '概览',
      details: '详情',
      empty: '暂无数据',
      loading: '加载中...',
      language: '语言',
      appearance: '外观',
      lightMode: '白色',
      darkMode: '深色',
      logout: '退出登录',
      role: '角色',
      account: '账号',
      today: '今天',
      thisWeek: '本周',
      thisMonth: '本月',
      thisYear: '本年',
      all: '全部',
      status: '状态',
      actions: '操作',
      amount: '金额',
      date: '日期',
      notes: '备注',
      confirm: '确认',
      tip: '提示',
      pleaseSelect: '请选择',
      selectDate: '选择日期',
      dateRangeStart: '开始',
      dateRangeEnd: '结束',
      loadFailed: '加载失败',
      self: '本人',
      active: '正常',
      inactive: '停用',
      failed: '操作失败',
      saved: '已保存',
      created: '已创建',
      deleted: '已删除',
      uploaded: '已上传',
      approved: '已批准',
      rejected: '已拒绝',
      submitted: '已提交',
      username: '账号',
      password: '密码',
      keyword: '关键词',
      required: '必填',
      requiredSelect: '必选',
      loadingShort: '加载中…',
      yes: '是',
      no: '否',
      selectAll: '全选',
      clearAll: '清空',
      nextAppt: '下次预约',
      optional: '选填',
      firstName: '名',
      lastName: '姓',
      company: '公司',
      source: '来源',
      contactSection: '联系人',
      sourceSection: '来源与跟进',
      assignSales: '分配销售',
      content: '内容',
      time: '时间',
      creator: '创建人',
      logoutConfirm: '确定退出登录？',
      logoutAction: '退出',
      backToList: '返回列表',
      downloadFailed: '下载失败',
      uploadFailed: '上传失败',
      linkCopied: '链接已复制',
      linkGenFailed: '生成链接失败',
      recordNotFound: '记录不存在',
      unnamedTemplate: '未命名模板',
      monthsHint: '月数（默认 12；结束日 = 开始日 + 期限）',
      unnamed: '未命名',
      preview: '查看'
    },
    navGroups: {
      workspace: '工作台',
      pipeline: '业务流程',
      finance: '财务',
      insights: '分析',
      admin: '系统管理'
    },
    nav: {
      dashboard: '仪表盘',
      leads: '线索',
      customers: '客户',
      opportunities: '商机',
      quotes: '报价',
      contracts: '合同',
      projects: '项目',
      products: '产品',
      subcontractors: '合作方',
      finance: '财务中心',
      reports: '报表',
      schedule: '日程',
      templates: '模板',
      settings: '设置中心',
      emailConfig: '邮箱配置',
      users: '用户',
      roles: '角色',
      menus: '菜单',
      systemOverview: '系统总览',
      changeOrders: '变更单',
      salesAmount: '销售额录入',
      home: '首页'
    },
    pipelineList: {
      leads: '在同一列表中跟踪负责人、预约与转化进度。',
      customers: '公司、联系人、地址与状态，对标 Salesforce Account。',
      opportunities: '支持线索转化或独立新建；阶段与胜率、赢单/丢单联动。',
      quotes: '内部审批、发送报价与向合同交接。',
      contracts: '从已批准报价生成合同，跟踪签署与关联项目。',
      projects: '项目编码、状态与项目经理相关财务字段。',
      subcontractors: '供应商与承包商统一目录，用于采购付款与现场分包协同。',
      changeOrders: '合同范围或金额调整，由办公室审批。',
      fromQuote: '从报价创建合同',
      newChangeOrder: '新建变更单',
      contractTemplates: '维护从报价生成合同时可选的 Word 模板、占位符与文件上传。'
    },
    leadListPage: {
      create: '新建线索',
      salesOwner: '销售负责人',
      leadStatusFilter: '线索状态',
      appointmentFrom: '预约日期起',
      appointmentTo: '预约日期止',
      leadNo: '线索编号',
      contactName: '联系人',
      appointmentDate: '预约日期',
      createdAt: '创建时间',
      viewDetails: '查看详情',
      assignSales: '分配销售',
      assignDialogTitle: '分配销售',
      loadSalesFailed: '加载销售列表失败',
      unnamed: '未命名',
      selectSalesOwnerWarn: '请选择销售负责人',
      assignSuccess: '分配成功',
      assignFailed: '分配失败',
      markLost: '丢失',
      confirmMarkLost: '确认将该线索标记为丢失吗？',
      confirmDelete: '确认删除该线索？（软删除）',
      deleteSuccess: '删除成功',
      latestNote: '最新备注',
      latestFollowup: '最新跟进'
    },
    routeTitles: {
      home: '首页',
      leadNew: '新建线索',
      leadEdit: '编辑线索',
      leadDetail: '线索详情',
      customerNew: '新建客户',
      customerEdit: '编辑客户',
      opportunityNew: '新建商机',
      opportunityDetail: '商机详情',
      quoteNew: '新建报价',
      quoteEdit: '编辑报价',
      contractFromQuote: '从报价创建合同',
      contractDetail: '合同详情',
      projectDetail: '项目详情',
      subcontractorNew: '新建合作方',
      subcontractorEdit: '编辑合作方',
      contractTemplateNew: '新建合同模板',
      contractTemplateEdit: '编辑合同模板'
    },
    grid: {
      number: '编号',
      title: '标题',
      code: '编码',
      name: '名称',
      createdAt: '创建时间',
      company: '公司',
      contact: '联系人',
      phone: '电话',
      email: '邮箱',
      customerNo: '客户编号',
      leadNo: '线索编号',
      customer: '客户',
      leadDisplayName: '线索名称',
      stage: '阶段',
      totalUsd: '总额 (USD)',
      winPct: '胜率%',
      closeDate: '关单日期',
      owner: '负责人',
      quote: '报价',
      template: '模板',
      project: '项目',
      contractId: '合同ID',
      amountDelta: '金额增减',
      approval: '审批',
      description: '说明',
      profit: '利润',
      pmCommission: 'PM佣金',
      licenseNo: '执照号',
      dba: '商号',
      personName: '姓名',
      version: '版本',
      username: '账号',
      realName: '姓名',
      roles: '角色',
      roleCode: '角色编码',
      roleName: '角色名称',
      userCount: '用户数',
      menuCount: '权限项',
      route: '路由',
      permissionCode: '权限标识',
      menuGroup: '分组',
      icon: '图标',
      visibility: '显示',
      sortOrder: '排序',
      content: '内容',
      time: '时间',
      createdBy: '创建人',
      contract: '合同',
      type: '类型',
      menuTypeMenu: '菜单',
      menuTypeButton: '按钮',
      visibleShow: '显示',
      visibleHide: '隐藏',
      revenue: '收入',
      expenseOut: '支出',
      changeOrderNoShort: '变更编号',
      fileName: '文件',
      fileSource: '来源',
      lineItem: '项目',
      qtyShort: '数量',
      unitPrice: '单价',
      lineSubtotal: '金额',
      viewProject: '查看'
    },
    loginPage: {
      subtitle: '欢迎登录业务管理平台',
      account: '账号',
      password: '密码',
      accountPh: '请输入账号',
      passwordPh: '请输入密码',
      submit: '登录',
      accountRequired: '请输入账号',
      passwordRequired: '请输入密码',
      failed: '登录失败'
    },
    customerListPage: {
      create: '新建客户',
      keywordLabel: '关键字',
      keywordPh: '姓名/电话/邮箱',
      salesOwner: '销售负责人'
    },
    opportunityListPage: {
      create: '新建商机',
      ownerFilter: '负责人',
      open: '打开'
    },
    quoteListPage: {
      create: '新建报价',
      customerSnapshot: '客户（快照）',
      quoteNoLabel: '报价编号',
      quoteNoPh: '编号模糊匹配',
      statusFilter: '报价状态',
      submitInternal: '提交审批',
      approve: '通过',
      reject: '拒绝',
      sendLink: '发送报价',
      view: '查看',
      submitted: '已提交内部审批',
      approved: '已审批',
      rejected: '已拒绝',
      rejectReason: '拒绝',
      linkTitle: '已生成',
      linkIntro: '客户访问链接（复制）：',
      linkEmailed: '报价已发送至线索邮箱：{email}',
      sendModeTitle: '发送报价',
      sendModeMessage: '请选择客户打开报价链接后可查看的内容。',
      sendModeSummary: '仅显示总金额',
      sendModeDetails: '可查看明细详情',
      sendQuoteFailTitle: '发送报价失败',
      sendQuoteFailed: '未能向客户发送报价邮件，请检查邮箱配置或稍后重试。',
      failed: '失败',
      createContract: '创建合同',
      viewContractDetail: '查看合同'
    },
    contractListPage: {
      keywordLabel: '关键词',
      statusLabel: '状态',
      searchPh: '搜索编号 / 标题',
      linked: '已关联',
      notCreated: '未建',
      emptyLoading: '加载中…',
      emptyHint: '暂无合同',
      gotoQuote: '报价'
    },
    changeOrderPage: {
      filterHint: '当前筛选合同 ID：{id}（来自合同页入口）',
      contractFilter: '合同',
      changeNoLabel: '变更单号',
      changeNoPh: '编号模糊匹配',
      approvalFilter: '审批状态',
      newDialog: '新建变更单',
      linkContract: '关联合同',
      contractPh: '搜索合同 ID 或选一条',
      amountPh: '正数增收，负数减收',
      descLabel: '变更说明',
      descPh: '说明变更范围与原因',
      selectContract: '请选择合同',
      created: '已创建',
      confirmApprove: '确定批准该变更单？',
      confirmReject: '确定拒绝该变更单？'
    },
    subcontractorListPage: {
      partyTypeFilter: '合作方类型',
      partyTypeAll: '全部',
      partyTypeCol: '类型',
      confirmDelete: '确认删除该合作方？',
      keywordLabel: '关键字',
      keywordPh: '公司 / 商号 / 联系人 / 执照号'
    },
    productListPage: {
      keywordLabel: '关键字',
      keywordPh: '产品名称 / 编码 / 描述',
      statusAll: '全部',
      confirmDelete: '确认删除该产品？已有报价会保留保存时的快照。'
    },
    projectListPage: {
      keywordLabel: '关键字',
      keywordPh: '项目编码或名称',
      customerCol: '客户',
      customerPhoneCol: '客户电话'
    },
    templateListPage: {
      keywordLabel: '关键字',
      keywordPh: '模板名称或版本',
      placeholderHelp: '占位符说明',
      preview: '预览',
      uploadFile: '上传文件',
      previewFailed: '预览失败',
      confirmDelete: '确定删除模板「{name}」？'
    },
    settingsPageExtra: {
      usersSubtitle: '维护系统账号、角色归属和登录状态。',
      rolesSubtitle: '维护角色编码、状态及其菜单/按钮授权。',
      menusSubtitle: '维护菜单、按钮权限以及前端导航元数据。'
    },
    workspaceHints: {
      leadNew: '录入联系人、公司与预约，便于后续跟进。',
      leadEdit: '更新联系方式、负责人分配与拜访安排。',
      leadDetail: '完整档案、备注、跟进记录与转化操作。',
      customerNew: '创建客户主数据，维护联系人与地址。',
      customerEdit: '调整公司信息、联系人与生命周期字段。',
      opportunityNew: '设置负责人、金额、阶段与预计关单时间。',
      opportunityDetail: '阶段推进、关联报价与活动记录。',
      quoteNew: '维护明细、条款与内部审批流程。',
      quoteEdit: '在客户确认或签署前调整范围与价格。',
      contractFromQuote: '选择已批报价与模板，生成合同文件。',
      contractDetail: '状态、关联项目、签署进度与附件。',
      projectDetail: '财务、付款计划、文档与交付状态。',
      subcontractorNew: '登记合作方类型、执照与联系人。',
      subcontractorEdit: '更新合作方资料与类型。',
      contractTemplateForm: '上传 Word 模板并维护合并占位符。',
      financeOverview: '回款、付款登记与跨项目利润视图。',
      leadCostMonth:
        '按月线索成本：按负责人当月名下项目合同额合计（月度销售额）阶梯计算，支持整月批量或单条重算。',
      salesAmount: '按销售与月份录入业绩，用于统计报表。'
    },
    systemUsersPage: {
      create: '新增用户',
      keywordPh: '账号/姓名/邮箱/电话',
      assignRoles: '分配角色',
      resetPassword: '重置密码',
      editUser: '编辑用户',
      newUser: '新增用户',
      passwordPh: '留空默认 123456',
      currentUser: '当前用户',
      resetPwdTitle: '重置密码',
      resetPwdHint: '将为账号 {username} 设置新密码。',
      newPwdPh: '请输入至少 6 位新密码',
      confirmReset: '确认重置',
      rulesUsername: '请输入账号',
      rulesPwdLen: '密码长度不能超过 64 位',
      rulesRealName: '请输入姓名',
      updated: '用户已更新',
      created: '用户已创建',
      saveFailed: '保存失败',
      statusUpdated: '状态已更新',
      statusFailed: '状态更新失败',
      rolesSaved: '角色分配已保存',
      pwdTooShort: '请输入至少 6 位新密码',
      pwdReset: '密码已重置',
      pwdFailed: '重置失败',
      confirmDelete: '确认删除用户 {name} 吗？',
      deleted: '用户已删除',
      deleteFailed: '删除失败'
    },
    systemRolesPage: {
      create: '新增角色',
      keywordPh: '角色编码/名称/描述',
      assignPerm: '分配权限',
      editRole: '编辑角色',
      newRole: '新增角色',
      permDialogTitle: '分配菜单权限',
      filterMenuPh: '筛选菜单或权限标识',
      rulesCode: '请输入角色编码',
      rulesName: '请输入角色名称',
      treePrefixBtn: '[按钮]',
      updated: '角色已更新',
      created: '角色已创建',
      menuLoadFailed: '权限树加载失败',
      permSaved: '权限配置已保存',
      permSaveFailed: '权限保存失败',
      confirmDelete: '确认删除角色 {name} 吗？',
      deleted: '角色已删除'
    },
    systemMenusPage: {
      createRoot: '新增顶级菜单',
      keywordPh: '名称/权限/路由',
      addChildMenu: '加子菜单',
      addChildBtn: '加按钮',
      editMenu: '编辑菜单',
      newMenu: '新增菜单',
      parentMenu: '上级菜单',
      topLevel: '顶级菜单',
      permPh: '如 SYSTEM_USER_CREATE',
      routePath: '路由路径',
      componentName: '组件名',
      purpose: '用途',
      defaultChild: '默认子路由',
      badgeType: 'Badge 类型',
      badgeSource: 'Badge 数据源',
      externalLink: '外链',
      hiddenLabel: '隐藏',
      displayStatus: '显示状态',
      enableStatus: '启用状态',
      showRadio: '显示',
      hideRadio: '隐藏',
      rulesName: '请输入名称',
      rulesType: '请选择类型',
      btnNeedPerm: '按钮必须填写权限标识',
      updated: '菜单已更新',
      created: '菜单已创建',
      confirmDelete: '确认删除 {name} 吗？',
      deleted: '菜单已删除',
      i18nKeyLabel: 'i18n Key',
      saveFailed: '保存失败'
    },
    leadFormPage: {
      editTitle: '编辑线索',
      newTitle: '新建线索',
      newSubtitle: '「名」为必填；姓与邮箱选填，其余按需填写。',
      leadNo: '线索编号',
      firstNamePh: '名',
      lastNamePh: '姓',
      emailPh: '邮箱',
      emailInvalid: '请输入有效邮箱地址',
      phonePh: '电话',
      sourcePh: '如：官网、展会、转介绍等',
      sourcePresetPh: '请选择来源',
      sourceYelp: 'Yelp',
      sourceOfficialSite: '官网',
      sourceGoogle: '谷歌',
      sourceMeta: 'Meta',
      sourceMagazine: '杂志',
      sourceOther: '其它',
      sourceOtherDetail: '填写来源',
      descriptionLabel: '描述',
      descriptionPh: '请输入描述，便于销售跟进。',
      addressLabel: '地址',
      addressPh: '联系或项目地址（选填）。',
      salesOwnerPh: '请选择销售负责人',
      officeOnly: '新建线索仅办公室/管理员可操作',
      apptPast: '预约日期须为今天或之后',
      saved: '已保存',
      created: '已创建',
      visitDivider: '现场拜访（Google 日历）',
      visitAlert:
        '可选拜访时段，日期与上方预约日期一致（业务时区默认 America/New_York）。填写有效时，将向负责销售与线索邮箱发送 Google 邀请。',
      visitOptional: '现场拜访（可选）',
      start: '开始',
      end: '结束',
      visitStart: '拜访开始',
      visitEnd: '拜访结束',
      visitStartPh: '可选 — 用于定时日历邀请',
      visitEndPh: '须晚于开始时间',
      visitPeriodMorning: '上午',
      visitPeriodAfternoon: '下午',
      visitPeriodPlaceholder: '上午 / 下午',
      visitTimePlaceholder: '时间',
      visitNeedAppointmentDate: '请先选择预约日期，再设置拜访时段。',
      visitNeedBothTimes: '请同时选择拜访开始与结束时间。',
      visitCascadeSeparator: ' / ',
      addressManualHint: '可选：在构建前端时配置 VUE_APP_GOOGLE_MAPS_API_KEY，以启用地址智能提示。'
    },
    leadDetailPage: {
      convertOpp: '转商机',
      createProject: '创建项目',
      newQuote: '新建报价',
      openOpp: '打开商机',
      tabBase: '基本信息',
      tabFollow: '跟进记录',
      tabNote: '内部备注',
      leadNo: '编号',
      writeFollow: '写跟进',
      addNote: '添加备注',
      followDialog: '跟进',
      followTime: '跟进时间',
      followTimePh: '默认保存时为当前时间',
      followType: '跟进类型',
      followContent: '内容',
      followContentPh: '跟进摘要',
      nextAppt: '下次预约',
      projectFromLead: '从线索创建项目',
      projectHint: '需该线索下已有合同（报价审批通过后创建）。项目将关联对应合同。',
      pmLabel: '项目经理',
      pmPh: '请选择项目经理',
      projectName: '项目名称',
      create: '创建',
      noteDialog: '内部备注',
      needPm: '请选择项目经理',
      needContent: '请填写内容',
      needNote: '请填写备注',
      projectOk: '项目已创建',
      projectFail: '失败（需先有合同）',
      oppOk: '已生成商机',
      visitWindow: '拜访时段',
      gcalSynced: '已同步到销售及办公室 Google 日历',
      gcalNotSynced: '未同步（负责人未关联或缺少 OAuth）',
      nextApptInline: '下次预约:',
      googleCalendar: 'Google 日历',
      leadCostSection: '线索成本',
      leadCostHint:
        '按负责人当月「月度销售额」（其名下于该月创建的项目合同额合计，含已批变更）与阶梯比例计算；项目或变更变化后请重算。',
      recalcLeadCost: '重算线索成本',
      leadCostAmount: '计算结果',
      leadCostOk: '线索成本已更新'
    },
    customerFormPage: {
      editTitle: '编辑客户',
      newTitle: '新建客户',
      newSubtitle: '主联系人与地址，字段均可选填，用于报价等。',
      customerNo: '客户编号',
      primaryContact: '主联系人',
      address: '地址',
      addrLine1: '地址行 1',
      addrLine2: '地址行 2',
      city: '城市',
      state: '州/省',
      zip: '邮编',
      country: '国家',
      countryPh: '如 US',
      notFound: '客户不存在',
      sectionPrimaryContact: '主联系人',
      sectionAddress: '地址',
      zipLabel: '邮编',
      salesOwner: '销售负责人',
      salesOwnerPh: '请选择销售负责人'
    },
    opportunityNewPage: {
      title: '新建商机',
      sub: '关联已有客户，或新建客户（不经过线索）。',
      customerSource: '客户来源',
      modeExisting: '已有客户',
      modeNew: '新建客户',
      customer: '客户',
      customerSearchPh: '按公司或电话搜索',
      companyName: '公司名称',
      contactFirst: '联系人名',
      contactLast: '联系人姓',
      oppName: '商机名称',
      initialStage: '初始阶段',
      owner: '负责人',
      ownerDefault: '默认本人',
      submit: '创建商机',
      ruleMode: '请选择',
      ruleCustomer: '请选择客户',
      ruleCompanyNew: '请输入公司名称',
      ruleOppName: '请输入商机名称',
      created: '商机已创建',
      failed: '创建失败',
      pickExisting: '选择已有客户',
      pickNew: '新建客户',
      labelEmail: '邮箱',
      labelPhone: '电话'
    },
    salesAmountPage: {
      cardTitle: '月度销售额',
      month: '月份（yyyy-MM）',
      amount: '销售额',
      salesperson: '销售员',
      saved: '已保存'
    },
    projectDetailPage: {
      recalc: '重算',
      recalcOk: '已重算',
      saved: '已保存',
      saveFailed: '保存失败',
      deleteExpenseConfirm: '确认删除该支出记录？',
      deletePaymentConfirm: '确认删除该收款记录？',
      deleteFail: '删除失败',
      uploadOk: '已上传',
      uploadFail: '上传失败',
      projectCode: '项目编号',
      projectName: '项目名称',
      projectStatus: '状态',
      contractNo: '合同编号',
      customerName: '客户',
      customerPhone: '客户电话',
      customerEmail: '客户邮箱',
      pm: '项目经理',
      assignedSub: '指派分包商',
      subcontractor: '分包商',
      subPlaceholder: '搜索并选择',
      download: '下载',
      attachmentDownloadUnavailable: '该附件无法从此处下载。',
      expenseTitle: '支出',
      paymentTitle: '收款',
      receivePayment: '收款',
      payee: '收款方',
      method: '方式',
      remark: '备注',
      reference: '参考号',
      paymentPlan: '付款计划',
      invoice: '发票',
      attachmentCol: '打开',
      changeOrderNo: '变更编号',
      planNodeName: '节点',
      planPlannedAmt: '计划金额',
      planActualAmt: '实际金额',
      planPlannedDateCol: '计划日',
      planActualDateCol: '实际日',
      attFile: '文件',
      attSource: '来源',
      attCreated: '创建时间',
      invoiceNum: '发票 #{id}',
      expenseValidatePayee: '请填写收款方。',
      expenseValidateAmount: '请填写有效的支出金额。',
      expenseValidateAmountPositive: '支出金额必须大于 0。',
      expenseValidateDate: '请选择支出日期。',
      expenseValidateMethod: '请填写付款方式。',
      paymentValidateAmount: '请填写有效的收款金额。',
      paymentValidateAmountPositive: '收款金额必须大于 0。',
      paymentValidateDate: '请选择收款日期。',
      paymentValidatePlan: '请选择付款计划节点。',
      paymentValidateMethod: '请填写收款方式。',
      paymentValidateReference: '请填写参考号 / 流水号。',
      supplementInvoice: '补发票',
      paymentInvoiceClickUpload: '点击上传发票',
      paymentInvoiceClickDownload: '点击下载发票',
      invoiceAttached: '已上传',
      invoiceNotAttached: '未上传',
      paymentSelectInvoiceFile: '请选择要上传的发票文件。',
      paymentInvoiceLinked: '发票已上传并关联。',
      paymentAlreadyHasInvoice: '该收款已关联发票。',
      invoiceNoOptional: '发票号码',
      paymentNewInvoiceSection: '发票信息',
      expenseKind: '支出类别',
      expenseKindCol: '类别',
      expenseTypeVendor: '供应商（采购）',
      expenseTypeSubcontractor: '承包商',
      expenseTypeMisc: '其他',
      payeeHint: '优先填写公司名，必要时可填项目名。',
      selectVendor: '供应商',
      selectSubcontractorParty: '承包商',
      expenseValidateParty: '请从目录中选择供应商或承包商。',
      expenseValidatePartyName: '所选合作方缺少公司名与商号，请先在合作方档案中补全。',
      colAttachments: '附件',
      expenseAttachmentListTitle: '支出附件',
      expenseAttachmentListEmpty: '该支出暂无附件。',
      paymentAttachmentListTitle: '收款附件',
      paymentAttachmentListEmpty: '该收款暂无附件。',
      uploadLinkedAttach: '上传',
      invoiceListTitle: '发票（本项目）',
      uploadMainInvoice: '上传主文件',
      invoiceColNo: '发票号码',
      invoiceMainFile: '发票主文件',
      invoiceExtraFiles: '附加文件',
      expenseOptionalAttachment: '附件（选填）',
      paymentOptionalAttachment: '附件（选填）',
      attachKind_custom: '通用',
      attachKind_invoice: '发票主文件',
      attachKind_invoiceAttach: '发票附加',
      attachKind_contractSigned: '已签署合同',
      attachKind_contractAttach: '合同附加',
      attachKind_quoteAttach: '报价附加',
      attachKind_expenseAttach: '费用',
      attachKind_paymentAttach: '收款记录',
      attachKind_changeOrder: '变更单文件',
      attachKind_changeOrderAttach: '变更单附加'
    },
    opportunityDetailPage: {
      crumbOpp: '商机',
      backList: '返回列表',
      save: '保存',
      panelFields: '字段',
      panelRelated: '相关',
      oppName: '商机名称',
      stage: '阶段',
      oppStatus: '商机状态',
      amountUsd: '预计金额 (USD)',
      winRate: '胜率 %',
      closeDate: '关单日期',
      owner: '负责人',
      ownerPh: '请选择销售',
      stageHint:
        '保存时按阶段自动套用默认胜率（管道逻辑）；也可在不改阶段时单独调整胜率。',
      newQuote: '新建报价',
      customerCompany: '客户公司',
      contactPerson: '联系人',
      email: '邮箱',
      phone: '电话',
      noCustomer: '无客户信息',
      leadSource: '来源线索',
      leadLoading: '加载线索中…',
      noLeadLinked: '无关联线索（独立创建的商机）',
      relatedQuotes: '相关报价',
      quoteNo: '报价编号',
      totalUsd: '总额 (USD)',
      quoteStage: '阶段',
      createdAt: '创建时间',
      actions: '操作',
      edit: '编辑',
      view: '查看',
      loadFailed: '加载失败',
      saved: '已保存',
      saveFailed: '保存失败'
    },
    quoteFormPage: {
      editTitle: '编辑报价',
      newTitle: '新建报价',
      newSubtitle: '关联线索并填写客户信息与明细行。',
      lockedAlert: '当前报价已锁定（审批中、已通过或已发送后不可修改）。请在列表中查看或使用「发送报价」。',
      sectionBase: '基本信息',
      sectionLines: '报价明细',
      sectionAttachments: '附件（关联项目下本报价）',
      attachEmpty: '暂无报价附件，可在下方上传。',
      attachView: '查看',
      attachDownload: '下载',
      lead: '关联线索',
      leadPh: '请选择线索',
      leadEmptyHint: '暂无可选线索，请先新建线索。',
      customerName: '客户名',
      firstNamePh: '名',
      lastNamePh: '姓',
      validUntil: '有效期',
      validUntilPh: '报价有效截止日',
      linesHint: '金额单位为美元 (USD)；逐项填写名称、数量、单价与加价百分比',
      addLine: '添加一行',
      colName: '名称',
      colProduct: '产品',
      colDescription: '描述',
      colQty: '数量',
      colUnitUsd: '单价 (USD)',
      colTaxPct: '加价%',
      colLineTotal: '行小计',
      removeLine: '移除',
      estimatedTotal: '预估合计：',
      save: '保存',
      saveDraft: '保存草稿',
      deleteDraft: '删除草稿',
      confirmDeleteDraft: '确定删除该报价草稿？删除后不可恢复。',
      deletedDraft: '草稿已删除',
      deleteDraftFailed: '删除失败',
      saveSubmitApproval: '保存并提交审批',
      createContractFromQuote: '从该报价创建合同',
      back: '返回',
      needLead: '请选择关联线索',
      needValidUntil: '请选择报价有效截止日',
      loadLeadFailed: '加载线索列表失败',
      saved: '已保存',
      created: '已创建',
      failed: '失败',
      submittedApproval: '已保存并提交内部审批',
      leadNum: '线索 #{id}',
      lineItemPh: '项目名称',
      descriptionPh: '本报价单行描述（可选；仅作用于本单，不会修改产品主档）',
      productPh: '请选择产品',
      productNum: '产品 #{id}',
      legacyLineItem: '已保存项目：',
      loadProductsFailed: '加载产品列表失败',
      addNewProduct: '＋ 新增产品…',
      sectionPaymentPlan: '付款计划',
      paymentPlanHint: '可选：填写各期回款节点，将展示在发给客户的报价单中，并在生成合同时带入模板。',
      addPlanNode: '添加节点',
      emptyPaymentPlans: '暂无付款计划节点。',
      colPlanNode: '节点名称',
      colPlanAmount: '计划金额 (USD)',
      colPlanDate: '计划日期',
      colPlanRemark: '备注',
      planNodePh: '如：定金',
      planAmountPh: '0.00',
      planDatePh: '计划日期',
      planPlannedTotal: '计划合计：',
      planUnplanned: '未分配：'
    },
    contractTemplateFormPage: {
      editTitle: '编辑合同模板',
      newTitle: '新建合同模板',
      newSubtitle: '填写名称与版本，在下方用 HTML 编写正文并可插入占位符。',
      newTip:
        '保存后即生成模板记录；使用 HTML 与合并占位符，生成合同时会替换占位符并由服务端排版输出 PDF。',
      name: '名称',
      namePh: '如：标准施工合同',
      version: '版本',
      versionPh: '如：v1.0、2026Q1',
      fileWhenNew: '模板文件',
      fileWhenEdit: '上传文件',
      chooseFile: '选择文件',
      chooseFileUpload: '选择文件并上传',
      pendingChosen: '已选择 {name}（点击保存时上传）',
      preview: '预览',
      uploadedBadge: '已上传',
      uploadHint:
        '当前仅支持 .docx；新建时可只填名称与版本，文件也可稍后在编辑页补传。Word 请下载后本地打开预览。',
      save: '保存',
      backList: '返回列表',
      ruleRequired: '必填',
      notFound: '记录不存在',
      loadFailed: '加载失败',
      saved: '已保存',
      created: '已创建',
      createdWithUpload: '已创建并上传模板文件',
      createUploadWarn: '模板已创建，但文件上传失败，请到列表进入编辑后重新上传',
      failed: '失败',
      uploaded: '已上传',
      uploadFail: '上传失败',
      previewFail: '预览失败',
      pageSizeLabel: '纸张大小',
      pageMarginsLabel: '页边距（mm）',
      pageMarginsPlaceholder: '上 右 下 左，空格分隔，例如 20 20 20 20',
      pageSizeLetter: 'US Letter',
      pageSizeA4: 'A4',
      pageSizeLegal: 'Legal',
      insertPlaceholderLabel: '插入占位符',
      insertPlaceholderPh: '请选择要插入的占位符',
      viewAllPlaceholders: '查看全部占位符',
      htmlBodyLabel: 'HTML 正文',
      htmlBodyPh: '<h1>服务协议</h1>\n\n合同编号 {{contract_no}}\n\n<p>…</p>',
      htmlBodyTipPrefix: '提示：请使用标准 HTML 标签；占位符如 ',
      htmlBodyTipSuffix: ' 会在生成合同时被替换。',
      livePreviewLabel: '实时预览',
      livePreviewHint: '预览展示 PDF 版面；签字区与付款计划占位符仅展示表格结构。',
      legacyDocxHint:
        '该模板曾为仅 DOCX 模式；请在下方补全 HTML 正文并保存；新签合同将仅从 HTML 生成 PDF。',
      placeholderDialogTitle: '合并占位符',
      phColPlaceholder: '占位符',
      phColDescription: '说明',
      phColActions: '操作',
      copyPlaceholder: '复制',
      copiedToClipboard: '已复制到剪贴板',
      htmlBodyRequired: '请填写 HTML 正文',
      previewCustomerSignature: '客户签字区',
      previewCompanySignature: '公司签字区',
      previewSignatureHint: '等待签署',
      previewPlanColIndex: '#',
      previewPlanColMilestone: '节点',
      previewPlanColAmount: '金额 (USD)',
      previewPlanColDue: '计划日期',
      previewPlanColNotes: '备注',
      previewPlanBanner: '模板占位符预览 — 生成合同时将替换为报价中的付款计划',
      previewPlanTextBanner: '模板占位符预览 — 生成合同时将替换为报价付款计划（纯文本）',
      previewPlanEmptyHint: '具体节点与金额来自关联报价，不会写入模板本身',
      previewPlanTextEmptyHint: '生成合同时将在此填入报价付款计划（纯文本）',
      sampleHtmlBody:
        '<h1>服务协议</h1>\n' +
        '<p style="color:#6b7280;">合同编号 {{contract_no}} · {{contract_title}}</p>\n\n' +
        '<h3>签约方</h3>\n' +
        '<p>本协议由 <strong>EHD Builders</strong> 与 <strong>{{customer_contact_name}}</strong>（{{customer_email}}）订立。</p>\n\n' +
        '<h3>期限</h3>\n' +
        '<p>自 {{contract_start_date}} 起至 {{contract_end_date}} 止（共 {{contract_term_months}} 个月）。</p>\n\n' +
        '<h3>对价</h3>\n' +
        '<p>合同总金额：<strong>{{quote_total_amount_fmt}} {{currency_code}}</strong>（报价单号 {{quote_no}}）。</p>\n\n' +
        '<h3>付款计划</h3>\n' +
        '{{payment_plan_table}}\n\n' +
        '<h3>签署</h3>\n' +
        '<p>双方签署即表示已知悉并同意本协议条款。</p>\n' +
        '<table style="width:100%;border-collapse:collapse;margin-top:14pt;"><tr>\n' +
        '<td style="width:50%;padding-right:18pt;vertical-align:top;">{{customer_signature}}</td>\n' +
        '<td style="width:50%;padding-left:18pt;vertical-align:top;">{{company_signature}}</td>\n' +
        '</tr></table>'
    },
    systemOverviewPage: {
      users: '用户',
      roles: '角色',
      menus: '菜单',
      oauth: 'OAuth',
      ready: '就绪',
      missing: '未配置'
    },
    subcontractorFormPage: {
      editTitle: '编辑合作方',
      newTitle: '新建合作方',
      newSubtitle: '供应商与承包商共用主数据，请设置类型以便支出时筛选。',
      partyType: '合作方类型',
      sectionMain: '主体信息',
      sectionLicense: '证照与联系',
      companyLegal: '法定公司名',
      companyLegalPh: '注册全称（可选）',
      tradeName: '对外名称',
      tradeNamePh: '现场常用名',
      contact: '联系人',
      contactPh: '联系人姓名',
      licenseNo: '执照号',
      licensePh: '执照或登记号',
      insurance: '保险',
      insurancePh: '保单说明',
      phonePh: '电话',
      emailPh: '邮箱',
      notFound: '记录不存在',
      saved: '已保存',
      created: '已创建',
      failed: '失败',
      ruleName: '必填'
    },
    productFormPage: {
      editTitle: '编辑产品',
      newTitle: '新建产品',
      newSubtitle: '由办公室维护产品主数据，创建报价明细时可直接选择。',
      productName: '产品名称',
      productNamePh: '如：标准橱柜安装',
      productCode: '产品编码',
      productCodePh: '选填，SKU 或内部编码',
      unitPrice: '单价',
      unitPricePh: 'USD',
      description: '描述',
      descriptionPh: '产品描述；报价中选此产品时会自动带入该行，可在报价里单独修改',
      notFound: '产品不存在',
      saved: '已保存',
      created: '已创建',
      failed: '失败',
      ruleName: '请填写产品名称',
      ruleUnitPrice: '请填写有效单价'
    },
    contractFromQuotePage: {
      title: '从报价创建合同',
      subtitle: '仅客户已同意的报价；金额与报价快照一致，并填写期限日期。',
      quoteSummary: '所选报价',
      selectQuote: '选择报价',
      quotePh: '请选择报价',
      quoteNo: '报价编号',
      lead: '线索',
      customer: '客户',
      quoteAmount: '报价金额',
      status: '状态',
      existingContract: '已有合同',
      viewContract: '查看 #',
      template: '合同模板',
      templatePh: '模板（可选）',
      contractTitle: '合同标题',
      titlePh: '默认：线索 · 报价编号',
      startDate: '开始日',
      startPh: '选择开始日期',
      scheduleBlockLabel: '日期与期限',
      termMonths: '期限',
      termOrEnd: '期限或结束日',
      termByMonths: '按月数',
      termByEndDate: '指定结束日',
      monthsHintShort: '结束日 = 开始日 + 月数。',
      endDateHint: '须不早于开始日。',
      needEndDate: '请选择结束日。',
      orEndDate: '或结束日',
      submit: '创建合同',
      endPh: '结束日期',
      submitOpenDetail: '创建并进入详情',
      loadQuotesFailed: '加载报价列表失败',
      loadContextFailed: '加载失败',
      selectQuoteWarning: '请选择可创建的报价（须为客户批准且尚未生成合同）',
      quoteNum: '报价 #{id}',
      templatePhLong: '选择预存模板（可选）',
      failed: '创建失败'
    },
    contractDetailPage: {
      backList: '返回列表',
      defaultTitle: '合同详情',
      changeOrdersThis: '本合同变更单',
      tabBase: '基本信息',
      tabChangeOrders: '合同变更单',
      tabPlans: '付款计划',
      tabInvoices: '发票',
      changeOrdersAllNav: '打开变更单列表（全局筛选）',
      quoteNo: '报价编号',
      template: '合同模板',
      linkedProject: '关联项目',
      projectHash: '项目 #',
      linkedProjectFallback: '项目 #{id}',
      quoteSnapshot: '报价金额快照',
      startDate: '开始日',
      endDate: '结束日',
      termMonths: '期限(月)',
      signer: '客户签署人',
      signedAt: '客户签署时间',
      signEmail: '签署邮箱',
      signIp: '签署 IP',
      createdAt: '创建时间',
      mergedDoc: '合并稿（模板生成）',
      noMergedTip: '暂无合并文件：创建时未选模板，或模板尚未上传源文件。',
      downloadMerged: '下载合并稿',
      viewMergedDoc: '查看合并稿',
      remerge: '重新合并',
      signedFile: '签署文件',
      signedFileTip: '上传客户签署后的扫描件或 PDF；下载用于核对已存档文件。',
      signedFileUploadedLabel: '已上传文件',
      signedFileNameUnknown: '未记录文件名（本次功能上线前上传）',
      uploadSigned: '选择文件并上传',
      downloadSigned: '下载签署文件',
      viewSignedDoc: '查看签署文件',
      publicLink: '客户公开链接',
      publicLinkTip: '生成客户公开合同页，用于在线查看、下载和确认签署。',
      copyContractLink: '复制合同链接',
      openPublic: '打开公开页',
      openEsignTrail: '电子签署轨迹',
      docsActionsTitle: '合并稿、签署文件与签署轨迹',
      esignFlowTitle: '电子签署流程（对标顺序签）',
      esignStepDraft: '待发客户',
      esignStepSent: '已发待签',
      esignStepCustomer: '客户已签',
      esignStepCompany: '公司已签',
      esignStepFinal: '终版已发',
      esignLegacy: '未使用顺序流程（传统模式）',
      esignRecipientPh: '客户收件邮箱（客户资料有邮箱时可不填）',
      sendInvite: '发送签署邀请邮件',
      companySign: '公司签署',
      sendFinal: '发送终版给客户',
      archiveFlow: '归档合同',
      downloadCustomerSigned: '下载客户已签版',
      downloadFullExecuted: '下载双方签署完整版',
      downloadSignedPackage: '下载签署版 PDF',
      signedPreviewCustomer: '客户已签合同预览',
      signedPreviewBoth: '双方签署合同预览',
      signedPdfLoading: '正在加载合同…',
      contractPreviewDraft: '合同文档',
      showContractPreview: '预览合同',
      hideContractPreview: '收起预览',
      downloadContractDoc: '下载',
      contractPreviewCollapsedHint: '点击上方「预览合同」后，将在此处展示合同内容。',
      remergeConfirm: '将按当前报价与模板重新生成合并稿。适用于发送给客户前补充信息。确定继续？',
      companySignerName: '签署人姓名',
      companySignerNameRequired: '请填写公司签署人姓名',
      companySignTitle: '公司方电子签名',
      archivePickFile: '可选上传归档件',
      esignInviteSent: '邀请邮件已发送',
      esignFinalSent: '终版邮件已发送',
      esignArchived: '合同已归档',
      esignWrongState: '当前步骤不允许此操作',
      esignTrail: '电子签署轨迹',
      esignSigner: '签署人',
      esignEmail: '签署邮箱',
      esignTime: '签署时间',
      esignIp: '签署 IP',
      esignUa: '设备信息',
      esignNote: '签署备注',
      downloadSigImg: '下载签名图',
      auditEvent: '事件',
      auditTime: '时间',
      auditSigner: '签署人',
      auditEmail: '邮箱',
      auditIp: 'IP',
      auditRemark: '备注',
      auditUa: '设备信息',
      toProject: '转为项目',
      openProject: '打开项目',
      toProjectDlgHint: '请选择项目经理；项目名称默认取报价中的客户姓名，可在保存前修改。',
      linkedOkTip: '已关联项目，可在上方链接进入项目详情维护付款计划、发票等。',
      pmLabel: '项目经理',
      pmPh: '请选择项目经理',
      pjName: '项目名称',
      pjNamePh: '默认与报价客户姓名一致，可修改',
      createProject: '创建项目',
      planHint: '在此登记各节点计划金额、实际回款与状态，用于项目经营简报中的「总回款」汇总。',
      planHintContract: '在此维护合同付款计划节点；关联项目后可登记实际回款。',
      planStatContractAmt: '合同金额',
      planStatContractAmtTip: '报价快照金额与已批准变更单金额之和。',
      planStatPlannedTotal: '计划付款合计',
      planStatUnplanned: '待计划付款金额',
      planStatUnplannedTip: '合同金额减去各节点计划金额之和（不为负时展示差额）。',
      addPlanNode: '新增付款节点',
      emptyPlans: '暂无节点，点击上方新增',
      nodeCol: '节点',
      plannedAmt: '计划金额',
      plannedDate: '计划日',
      actualAmt: '实际金额',
      actualDate: '实际日',
      emptyNeedProject: '请先在本页「基本信息」中创建关联项目，再维护付款计划',
      registerInvoice: '登记发票',
      emptyInvoices: '暂无发票记录',
      invNo: '发票号',
      invType: '类型',
      invAmt: '金额',
      invDate: '开票日',
      uploadFile: '上传文件',
      customerLink: '客户链接',
      emptyInvNeedProj: '请先创建关联项目后再登记发票',
      editPlanTitle: '编辑付款节点',
      nodeName: '节点名称',
      planAmt: '计划金额',
      planAmtPh: 'USD',
      planDatePh: '选填',
      actualAmtPh: '已回款金额',
      statusPh: '状态',
      invRegisterTitle: '登记发票',
      invAmtUsd: '金额 (USD)',
      auditViewed: '查看',
      auditDownloaded: '下载',
      auditSigned: '签署',
      auditSentInvite: '发送邀请邮件',
      auditCompanySigned: '公司签署',
      auditFinalEmail: '终版邮件',
      auditArchived: '归档',
      auditUnknown: '未知',
      showViewAudits: '显示「查看」记录',
      auditViewHiddenHint: '已隐藏 {count} 条「查看」记录，可勾选上方选项显示。',
      auditTableEmptyFiltered: '当前列表仅有「查看」记录，请勾选上方开关显示。',
      loadPmFailed: '加载用户列表失败',
      signedUploaded: '已上传',
      mergeRegenerated: '已重新生成合并文件',
      noSignedFile: '暂无已上传的签署文件',
      noSignatureImg: '暂无客户签名图',
      selectPmWarn: '请选择项目经理',
      defaultProjectName: '项目',
      defaultNodePrefix: '节点',
      deletePlanConfirm: '确定删除该付款节点？',
      deleted: '已删除',
      planSaved: '已保存',
      invoiceRegistered: '已登记',
      invoiceUploaded: '已上传',
      extraQuoteContractFiles: '报价与合同附加文件',
      extraQuoteContractTip: '在已关联项目上上传的补充材料，可按报价 / 合同分别归类并在此查看、下载。',
      quoteExtraSection: '报价附加',
      contractExtraSection: '合同附加',
      extraAttachEmpty: '暂无附加文件',
      downloadExtraAttach: '下载',
      previewExtraAttach: '查看',
      invoiceLinkCopied: '发票公开链接已复制',
      copyContractOk: '合同公开链接已复制',
      projectCreated: '项目已创建',
      saveFail: '保存失败',
      actionFail: '失败',
      planMutateOnlyPlanning: '仅「计划中」的付款节点可编辑或删除。',
      planValidateNodeName: '请填写节点名称。',
      planValidatePlannedAmount: '请填写计划金额（有效数字）。',
      planValidatePlannedDate: '请选择计划日。'
    },
    mergeDialog: {
      title: '占位符说明',
      intro: '在 Word 模板中可使用以下合并字段。',
      dialogTitle: '合同模板占位符说明',
      colWrite: '写法（原样复制）',
      colMerge: '合并为',
      gotIt: '知道了',
      note: '说明：对外发给客户的应是合并后的 Word/HTML 文件，客户无需了解占位符。下表供内部同事编写模板时使用；在正文里写英文双花括号，例如 {{quote_no}}。',
      placeholders: {
        contract_no: '合同编号',
        contract_title: '合同标题',
        contract_start_date: '合同开始日 yyyy-MM-dd',
        contract_end_date: '合同结束日 yyyy-MM-dd',
        contract_term_months: '合同期限（月）',
        contract_created_date: '合同记录创建日（日期）yyyy-MM-dd',
        contract_created_at: '合同记录创建时间 ISO 格式',
        contract_creator_name: '创建人姓名（系统用户）',
        quote_no: '报价编号',
        quote_total_amount: '报价总额（数字）',
        quote_total_amount_fmt: '报价总额（千分位两位小数）',
        currency_code: '币种代码，如 USD',
        quote_valid_until: '报价有效期截止日 yyyy-MM-dd',
        opportunity_no: '线索编号',
        opportunity_name: '线索名称（联系人姓名）',
        opportunity_amount: '报价总额（数字）',
        opportunity_amount_fmt: '报价总额（千分位两位小数）',
        opportunity_close_date: '预留（关闭日）',
        opportunity_probability: '预留（胜率）',
        opportunity_owner_name: '线索负责人（销售）姓名',
        customer_no: '客户编号',
        customer_company_name: '兼容占位：主联系人姓名（名+姓），与 customer_contact_name 含义一致',
        customer_first_name: '客户名',
        customer_last_name: '客户姓',
        customer_contact_name: '客户联系人姓名（名+姓）',
        customer_email: '客户邮箱',
        customer_phone: '客户电话',
        customer_address_line1: '客户地址行1',
        customer_address_line2: '客户地址行2',
        customer_city: '城市',
        customer_state: '州/省代码',
        customer_zip: '邮编',
        customer_country: '国家代码',
        customer_address_full: '客户地址拼接一行',
        template_name: '所选合同模板名称',
        template_version: '模板版本标识',
        today: '合并生成当日 yyyy-MM-dd',
        project_code: '关联项目编码（无项目则为空）',
        project_name: '关联项目名称（无项目则为空）',
        payment_plan_table: '付款计划 HTML 表格（来自报价；HTML 模板中插入整段）',
        payment_plan_text: '付款计划纯文本列表（Word 模板适用）',
        customer_signature: '客户签字区（草稿阶段为空框；客户签后渲染为客户签字图块）',
        company_signature: '公司签字区（草稿阶段为空框；公司签后渲染为公司签字图块）'
      }
    },
    dashboardExtra: {
      pipelineSubtitle: '从线索到回款，全流程在一套管道中跟踪。'
    },
    dashboardPage: {
      title: '销售工作台',
      subtitle: '统一查看审批、签署、财务与日程。',
      kpiNewLeads: '本周新增线索',
      kpiLeadsStats: '新增线索',
      kpiLeadsWeek: '本周',
      kpiLeadsMonth: '本月',
      kpiLeadsYear: '本年',
      kpiQuotesPending: '待审批报价',
      kpiContractsAwaiting: '待签合同',
      kpiSignedValue: '本月签约金额',
      pipelineTitle: '业务转化',
      tasksTitle: '我的待办',
      actionsTitle: '快捷入口',
      recentTitle: '最近动态',
      calendarTitle: 'Google 日历集成',
      calendarConnected: '已连接',
      calendarDisconnected: '未连接',
      calendarSummary: '主日历',
      connectCalendar: '连接 Google 日历',
      disconnectCalendar: '断开连接',
      gotoLeads: '新建线索',
      gotoQuote: '新建报价',
      gotoSchedule: '我的日程',
      gotoContracts: '合同列表',
      gotoReports: '报表中心',
      gotoFinance: '财务中心',
      gotoSalesPersonReport: '销售人员报表',
      statLeadsMtd: '本月线索',
      statContractsMtd: '本月签合同',
      statConversion: '转化率',
      taskCountItems: '{count} 条',
      calendarLeadSyncHint:
        '线索拜访会同步到所选销售及所有已连接 Google 日历的办公室用户；在 CRM 中的修改也可回写到 Google。',
      redirectingOAuth: '正在跳转…',
      disconnectingOAuth: '正在断开…',
      googleConnectedToast: '已连接 Google 日历',
      googleAuthErrorPrefix: 'Google 授权失败：',
      googleAuthUnknownReason: '未知错误',
      oauthCannotStart: '无法启动授权',
      noAuthUrlReturned: '未返回授权地址',
      disconnectGoogleConfirm: '确定断开当前用户的 Google 日历连接？',
      disconnectGoogleTitle: '确认',
      disconnectedToast: '已断开',
      disconnectFailed: '断开失败',
      salesReportCardTitle: '销售人员报表',
      salesReportColSales: '销售',
      salesReportColQuotes: '待审批报价',
      salesReportColContracts: '待签合同',
      salesReportColActions: '操作',
      salesReportViewDetail: '查看详情',
      salesReportSalesHint:
        '当前待审批报价 {q} 条，待签合同 {c} 条。打开完整报表可按条件导出明细。',
      salesReportOpenFull: '打开完整报表'
    },
    schedulePage: {
      title: '我的日程',
      calendarPanel: '日历',
      subtitle: '展示 CRM 线索拜访；在首页连接 Google 日历后可同步到个人日历。',
      upcoming: '即将到来的拜访',
      monthEvents: '本月拜访',
      prev: '上月',
      next: '下月',
      syncedLead: '线索拜访',
      notConnected: '尚未连接 Google Calendar。',
      emptyEventsMonth: '本月暂无拜访安排',
      colEventStart: '开始',
      colEventEnd: '结束',
      colEventTitle: '标题',
      colAssignedSales: '负责销售',
      openLead: '线索',
      openInGoogle: 'Google',
      noEventTitle: '（无标题）',
      loadFailed: '加载日程失败',
      connectGoogle: '去连接 Google 日历',
      hintSelfGoogle:
        '您尚未连接 Google 日历，拜访仍可在本页查看；连接后将自动同步到您的 Google 日历。',
      hintOfficePendingGoogle:
        '以下办公室用户尚未连接 Google 日历，连接后将自动同步历史与未来拜访：{names}'
    },
    reportPage: {
      title: '数据分析与报表',
      subtitle: '跟踪线索转化、签约金额、回款、支出和利润。',
      pipeline: '线索漏斗',
      finance: '项目财务',
      exportLead: '导出线索',
      exportProject: '导出项目财务',
      latestProjects: '最近项目',
      projectFinanceSnapshot: '项目财务快照',
      pipeQuoteAmount: '报价金额',
      pipeContractAmount: '合同金额',
      tableProjectCode: '项目编号',
      tableProjectName: '项目名称',
      tableRevenue: '总合同额',
      tableExpense: '支出',
      tableProfit: '利润',
      leadChartTitle: '线索状态分布',
      financeReceived: '已收款'
    },
    salesPersonReportPage: {
      title: '销售人员报表',
      subtitle: '按销售筛选、预览明细并导出多工作表 Excel。',
      export: '导出 Excel',
      salesperson: '销售人员',
      allSales: '全部销售',
      onlyUnassigned: '仅未分配负责人的线索',
      scopeLabel: '范围',
      sectionLeads: '日期范围内的新增线索',
      sectionPendingQuotes: '待内部审批的报价（当前快照）',
      sectionPendingContracts: '待签署合同（当前快照）',
      sectionSignedContracts: '日期范围内已签署合同',
      colSales: '销售',
      colLeadNo: '线索编号',
      colFirstName: '名',
      colLastName: '姓',
      colEmail: '邮箱',
      colStatus: '线索状态',
      colCreatedAt: '创建时间',
      colQuoteNo: '报价编号',
      colQuoteStatus: '报价状态',
      colUpdatedAt: '更新时间',
      colContractNo: '合同编号',
      colContractStatus: '合同状态',
      colSignedAt: '签署时间',
      colSignedValueUsd: '签约金额（USD）'
    },
    leadCostMonthPage: {
      title: '线索成本（按月）',
      subtitle:
        '月度销售额 = 该销售负责人在该自然月内创建的项目之合同额合计（合同报价快照 + 已批准变更单），与项目财务总合同额口径一致。≤ 140,000 → 20%；> 140,000 → 15%。每条线索每月一条记录。服务端默认每日凌晨自动重算「当前自然月」（可在配置中关闭或改 cron）。',
      periodMonth: '月份（yyyy-MM）',
      recalcMonth: '整月批量重算',
      recalcRow: '重算',
      colLead: '线索',
      colOwner: '负责人',
      colMonthlySales: '月度销售额（合同额合计）',
      colCost: '线索成本',
      colRatio: '适用比例',
      colComputed: '最近计算时间',
      goProjectList: '打开项目列表',
      doneBatch: '批量重算已完成'
    },
    financeCenterPage: {
      leadCostNav: '线索成本（按月）',
      overviewTotalContract: '项目合同额合计',
      operatingExpenseHint: '支出',
      totalLeadCostHint: '线索成本',
      colContractTotal: '总合同额',
      colTotalExpense: '总支出'
    },
    projectPage: {
      title: '项目工作台',
      subtitle: '统一管理项目财务、文档、付款计划和利润快照。',
      overview: '项目概览',
      financials: '财务',
      documents: '文档',
      activity: '动态',
      summary: '财务摘要',
      totalSales: '总销售额',
      contractAmount: '合同额',
      originalContractAmount: '原合同额',
      changeOrderAmountApproved: '变更合同额（已批准）',
      contractAmountTotal: '总合同额',
      totalReceived: '已收款',
      totalBalance: '待收余额',
      totalExpense: '总支出',
      operationalExpense: '支出',
      profit: '利润',
      profitMargin: '利润率',
      pmCommission: '项目经理佣金',
      leadCost: '线索成本',
      miscExpense: '杂项支出',
      projectExpense: '项目支出流水',
      changeOrders: '变更单',
      paymentPlan: '付款计划',
      paymentRecords: '收款记录',
      expenses: '支出记录',
      attachments: '附件归档'
    },
    publicQuote: {
      title: '报价查看',
      subtitle: '在线查看报价明细并提交审批结果。',
      statusChipViewed: '请审阅并作出决定',
      notSentYet: '本报价尚未发送给您。',
      decisionUnavailable: '当前状态下无法提交审批结果。',
      approve: '批准',
      reject: '拒绝',
      accept: '接受',
      decline: '拒绝',
      comment: '意见（可选）',
      submitted: '已提交结果',
      accepted: '您已接受本报价。',
      rejected: '您已拒绝本报价。',
      total: '合计',
      estimateTotal: '报价总金额',
      viewEstimate: '查看报价明细',
      summaryModeIntro: '如需推进该报价，请点击接受，EHD Builders 会与您联系下一步安排。',
      detailModeIntro: '展开后可查看完整报价明细行。如需推进该报价，请点击接受，EHD Builders 会与您联系下一步安排。',
      detailModeIntroCollapsed:
        '点击「查看报价明细」可展开完整分项。如需推进该报价，请点击接受，EHD Builders 会与您联系下一步安排。',
      hideEstimate: '收起明细',
      docTitle: '报价单',
      docBillTo: '客户',
      docEstimateNo: '报价编号',
      docValidThrough: '有效期至',
      docTotal: '合计',
      celebrationTitle: '太好了！',
      celebrationSubtitle: '您已接受本报价。',
      celebrationNext: '我们已通知 EHD Builders，对方将与您联系后续事宜。',
      celebrationMetaBusiness: '公司',
      celebrationMetaAccepted: '接受日期',
      celebrationMetaTotal: '报价总额',
      detailsTitle: '报价明细',
      colIndex: '#',
      colProduct: '产品 / 服务',
      colDescription: '描述',
      noDetails: '暂无报价明细。',
      colItem: '项目',
      colQty: '数量',
      colUnitPrice: '单价',
      colAmount: '金额',
      paymentPlanTitle: '付款计划',
      colPlanNode: '节点',
      colPlanDate: '计划日期',
      planTotal: '计划合计'
    },
    publicContract: {
      title: '合同查看',
      subtitle: '在线查看合同内容并确认签署。',
      sign: '确认签署',
      signerName: '签署姓名',
      signerEmail: '签署邮箱',
      note: '备注',
      signed: '合同已确认签署',
      download: '下载合同',
      downloadNotReady: '合同文件尚未生成，暂不可下载。',
      downloadNotReadyHint: '请工作人员在系统中执行「重新生成合同文档」生成合并文件后，客户即可在此下载。',
      signUnavailableNoFile:
        '合同合并文件尚未生成，暂时无法在线签署。请工作人员在系统中生成合同文档后再分享链接。',
      signUnavailableArchived: '该合同已归档或已取消，无法在线签署。',
      signUnavailableWrongStep:
        '当前尚未进入「客户签署」步骤。请在收到邀请邮件后通过邮件中的链接打开本页进行签署。',
      status: '状态',
      contract: '合同',
      startDate: '开始日期',
      endDate: '结束日期',
      term: '期限',
      amount: '金额',
      signedByCustomer: '客户签署人',
      signedAt: '签署时间',
      contractItems: '合同明细',
      item: '项目',
      description: '说明',
      qty: '数量',
      signature: '手写签名',
      clear: '清空',
      signHere: '请在此签名',
      submitFailed: '提交失败',
      loadFailed: '合同加载失败',
      alreadyCompleted: '该合同已完成，或当前不支持在线签署。',
      signRequired: '请先完成手写签名'
    },
    publicInvoice: {
      title: '发票查看',
      subtitle: '在线查看发票信息并下载发票文件。',
      download: '下载发票',
      amountHead: '金额',
      labelInvoiceNo: '发票号',
      labelDate: '日期',
      labelProject: '项目',
      projectChip: '项目',
      invoiceNum: '发票 #{id}'
    },
    emailConfigPage: {
      subtitle: '配置个人 SMTP，用于向客户发送报价查看链接。',
      intro:
        '「报价 → 发送报价」将使用此处 SMTP 向客户发信。本菜单由「菜单管理」维护并分配给角色；若看不到侧栏入口，请联系管理员勾选「邮箱配置」。587 端口一般开启 STARTTLS；465 一般使用 SSL。公开链接根地址留空则使用服务器默认。',
      smtpHost: 'SMTP 服务器',
      smtpHostPh: '例如 smtp.gmail.com',
      smtpHostRequired: '请填写 SMTP 服务器',
      smtpPort: 'SMTP 端口',
      smtpPortRequired: '请填写端口',
      smtpUsername: 'SMTP 用户名',
      smtpUsernamePh: '通常为完整邮箱地址',
      smtpUsernameRequired: '请填写 SMTP 用户名',
      smtpPassword: 'SMTP 密码',
      passwordPh: '邮箱密码或应用专用密码',
      passwordKeep: '不修改请留空',
      passwordRequired: '首次保存必须填写密码',
      fromEmail: '发件人邮箱',
      fromEmailPh: '可留空，默认与 SMTP 用户名相同',
      fromPersonal: '发件人显示名',
      fromPersonalPh: '可留空',
      ssl: 'SSL',
      sslOn: 'SSL（常见 465）',
      starttls: 'STARTTLS',
      starttlsOn: 'STARTTLS（常见 587）',
      publicBase: '公开链接根地址',
      publicBasePh: '例如 http://localhost:8080，须与客户浏览器访问前端的地址一致',
      save: '保存',
      saveOk: '已保存',
      saveFail: '保存失败',
      loadFail: '加载失败'
    },
    settingsPage: {
      title: '设置中心',
      subtitle: '统一管理用户、角色、菜单权限、模板和系统集成。'
    },
    enum: {
      unknown: '未知({value})',
      quoteStatus: {
        1: '草稿',
        2: '内部通过',
        3: '内部拒绝',
        4: '已发送',
        7: '客户已查看（待决策）',
        5: '客户批准',
        6: '客户拒绝'
      },
      quoteInternalApproval: {
        0: '未提交',
        1: '待审批',
        2: '内部通过',
        3: '已拒绝'
      },
      quoteCustomerDecision: {
        1: '未决定',
        2: '客户批准',
        3: '已拒绝'
      },
      contractStatus: {
        1: '草稿',
        2: '已上传',
        3: '已签署',
        4: '已归档',
        5: '已取消'
      },
      templateStatus: {
        1: '启用',
        2: '停用'
      },
      paymentPlanStatus: {
        1: '计划中',
        2: '已开票',
        3: '已付款'
      },
      changeOrderApproval: {
        1: '草稿',
        2: '已提交',
        3: '已批准',
        4: '已拒绝'
      },
      invoiceType: {
        1: '普通',
        2: '变更单'
      },
      projectStatus: {
        1: '计划中',
        2: '进行中',
        3: '已完成',
        4: '已取消'
      },
      leadStatus: {
        1: '新建',
        2: '跟进中',
        3: '合格',
        4: '已转化',
        5: '丢失'
      },
      opportunityStage: {
        1: '开发',
        2: '方案',
        3: '报价',
        4: '谈判',
        5: '赢单',
        6: '丢单'
      },
      customerStatus: {
        1: '有效',
        2: '停用'
      },
      opportunityStatus: {
        1: '进行中',
        2: '已赢单',
        3: '已丢单'
      },
      invoiceStatus: {
        1: '已上传',
        2: '已确认'
      },
      followupType: {
        1: '电话',
        2: '会议',
        3: '邮件',
        4: '其他',
        5: '拜访'
      },
      subcontractorParty: {
        1: '供应商（采购）',
        2: '承包商',
        3: '均可'
      },
      productStatus: {
        1: '启用',
        2: '停用'
      }
    }
  }
}

export default messages
